// Catalogo de. Generado a mano; el test de catalogos garantiza que los tres coinciden.
export default {
    'app.nombre': 'Soluxe Management',
    'app.cargando': 'Wird geladen...',
    'app.guardar': 'Speichern',
    'app.si': 'Ja',
    'app.no': 'Nein',
    'app.anadir': 'Hinzufügen',
    'app.cancelar': 'Abbrechen',
    'aj.subtitulo': 'Dein Unternehmen, dein Konto und was dich benachrichtigt.',
    'aj.organizacion': 'Organisation',
    'aj.organizacionPie': 'Steuerliche Identität und Anschrift',
    'aj.marca': 'Marke und Erscheinungsbild',
    'aj.marcaPie': 'Farben und Logos',
    'aj.categorias': 'Ausgabenkategorien',
    'aj.categoriasPie': 'Der Ausgabenplan des Hauses',
    'aj.notificaciones': 'Benachrichtigungen',
    'aj.notificacionesPie': 'Was dich auf dem Gerät benachrichtigt',
    'aj.seguridad': 'Sicherheit',
    'aj.seguridadPie': 'Passwort, Passkeys und zweiter Faktor',
    'aj.integraciones': 'Integrationen',
    'aj.integracionesPie': 'Schlüssel für externe Dienste',
    'aj.apartados': 'Einstellungsbereiche',
    'aj.identidad': 'Identität',
    'aj.faltanDatos': 'Rechnungsdaten fehlen',
    'aj.identidadPie': 'Den Handelsnamen sieht dein Team. Firmenname und Steuernummer stehen auf der Rechnung.',
    'aj.nombreComercial': 'Handelsname',
    'aj.nombreComercialPie': 'Der Name im Menü und in den Berichten.',
    'aj.razonSocial': 'Firmenname',
    'aj.razonSocialPie': 'Der eingetragene Name des Unternehmens.',
    'aj.nif': 'Steuernummer',
    'aj.nifPie': 'Wird ohne Leerzeichen und Bindestriche gespeichert.',
    'aj.domicilio': 'Firmensitz',
    'aj.domicilioPie': 'Die Anschrift auf den Rechnungen, die du ausstellst.',
    'aj.direccion': 'Adresse',
    'aj.codigoPostal': 'Postleitzahl',
    'aj.poblacion': 'Ort',
    'aj.provincia': 'Provinz',
    'aj.pais': 'Land',
    'aj.colores': 'Farben',
    'aj.coloresPie': 'Sie gelten für die App und die erzeugten Dokumente. Statusfarben — grün, gelb, rot — ändern sich nicht: Sie sagen, ob etwas in Ordnung ist, und das ist keine Frage der Marke.',
    'aj.colorAcento': 'Akzentfarbe',
    'aj.colorAcentoPie': 'Schaltflächen, Links und Hervorhebungen',
    'aj.colorCabecera': 'Kopfzeilenfarbe',
    'aj.colorCabeceraPie': 'Kopfzeile und Seitenleiste',
    'aj.colorSecundario': 'Sekundärfarbe',
    'aj.colorSecundarioPie': 'Beschriftungen und Details',
    'aj.hexadecimal': '{campo} in Hexadezimal',
    'aj.logotipos': 'Logos',
    'aj.logotiposPie': 'Eines für dunklen und eines für hellen Hintergrund: Dasselbe Logo liest sich nicht auf beiden gut.',
    'aj.sobreOscuro': 'Auf dunklem Hintergrund',
    'aj.sobreClaro': 'Auf hellem Hintergrund',
    'aj.sinLogotipo': 'Kein Logo',
    'aj.subir': 'Hochladen',
    'aj.cambiar': 'Ersetzen',
    'aj.subiendo': 'Wird hochgeladen…',
    'aj.quitar': 'Entfernen',
    'aj.vistaPrevia': 'Vorschau',
    'aj.vistaPreviaPie': 'Änderungen erscheinen hier sofort. Zum Übernehmen „Speichern“ drücken.',
    'aj.dePropiedad': 'Objektbezogen',
    'aj.dePropiedadPie': 'Die Kategorien beim Erfassen einer Hausausgabe; diese sieht der Eigentümer in seinem Portal.',
    'aj.internas': 'Intern',
    'aj.internasPie': 'Die eigenen Kosten der Organisation, die keinem Objekt belastet werden.',
    'aj.categoriasPie2': 'Kategorien hinzufügen, umbenennen oder deaktivieren. Eine deaktivierte wird nicht mehr angeboten; bereits erfasste Ausgaben zählen weiter.',
    'aj.sistema': 'System',
    'aj.nGastos': '{total} Ausgaben',
    'aj.unGasto': '1 Ausgabe',
    'aj.activa': 'Aktiv',
    'aj.oculta': 'Ausgeblendet',
    'aj.activaAyuda': 'Wird beim Erfassen einer Ausgabe angeboten',
    'aj.ocultaAyuda': 'Beim Erfassen ausgeblendet',
    'aj.borrar': 'Löschen',
    'aj.anadirCategoria': 'Kategorie hinzufügen',
    'aj.nombreCategoria': 'Name der Kategorie',
    'aj.ambito': 'Bereich der Kategorie',
    'aj.nombreDe': 'Name von {nombre}',
    'aj.avisosPie': 'Wähle, was dich auf dem Gerät benachrichtigt. In der Glocke der App erscheinen weiterhin alle Hinweise.',
    'avisosMovil.titulo': 'Hinweise auf diesem Gerät',
    'avisosMovil.encendido': 'Aktiv. Sie kommen auch bei geschlossener App an.',
    'avisosMovil.apagado': 'Auf diesem Gerät deaktiviert.',
    'avisosMovil.denegado': 'Der Browser blockiert sie. In den Systemeinstellungen für diese App aktivieren.',
    'avisosMovil.noSoportado': 'Dieser Browser unterstützt sie nicht. Auf dem iPhone: App zum Home-Bildschirm hinzufügen und von dort öffnen.',
    'avisosMovil.sinClave': 'Auf dem Server noch nicht eingerichtet.',
    'avisosMovil.encender': 'Aktivieren',
    'avisosMovil.apagar': 'Deaktivieren',
    'avisosMovil.noSePudo': 'Die Hinweise konnten auf diesem Gerät nicht aktiviert werden.',
    'avisosMovil.instalar': 'Ein Schritt fehlt: Auf dem iPhone funktionieren Hinweise nur, wenn die App zum Home-Bildschirm hinzugefügt ist.',
    'avisosMovil.paso1': 'Öffne diese Seite in Safari und tippe auf „Teilen“ (das Quadrat mit dem Pfeil nach oben).',
    'avisosMovil.paso2': 'Wähle „Zum Home-Bildschirm“ und bestätige.',
    'avisosMovil.paso3': 'Öffne SOLUXE über das neue Symbol, komm hierher zurück und tippe auf Aktivieren.',
    'avisosMovil.ninguno': 'Der Server hat kein Gerät für dich registriert. Solange keines da ist, kann kein Hinweis rausgehen.',
    'avisosMovil.dispositivoSinNombre': 'Gerät',
    'avisosMovil.este': 'dieses',
    'avisosMovil.ultimo': 'Letzter Hinweis erhalten am {fecha}',
    'avisosMovil.nuncaRecibio': 'Hat noch keinen erhalten',
    'avisosMovil.conFallos': 'Fehler in Folge: {n}',
    'avisosMovil.probar': 'Testhinweis schicken',
    'avisosMovil.probando': 'Wird gesendet…',
    'avisosMovil.entregado': 'An {dispositivo} zugestellt. Wenn nichts kam: Systemeinstellungen → Mitteilungen → SOLUXE.',
    'avisosMovil.rechazado': '{dispositivo} hat ihn abgelehnt ({codigo}). {motivo}',
    'aviso.CLIENTE_INCIDENCIA': 'Kunde meldet einen Vorgang',
    'aviso.CLIENTE_INCIDENCIAPie': 'Aus seinem Portal, im Moment der Meldung',
    'aviso.CLIENTE_ESTANCIA': 'Kunde kündigt einen Aufenthalt an',
    'aviso.CLIENTE_ESTANCIAPie': 'Wenn er seine Ankunft mit Daten meldet',
    'aviso.CLIENTE_MENSAJE': 'Kunde schreibt zu einem Vorgang',
    'aviso.CLIENTE_MENSAJEPie': 'Eine Nachricht im Verlauf, die eine Antwort erwartet',
    'aviso.INCIDENCIA_RESUELTA': 'Ein Vorgang wird geschlossen',
    'aviso.INCIDENCIA_RESUELTAPie': 'Wenn jemand aus dem Team ihn als gelöst markiert',
    'aviso.GASTO_ALTO': 'Hohe Ausgabe',
    'aviso.INCIDENCIA_NUEVA': 'Neuer Vorfall',
    'aviso.INCIDENCIA_NUEVAPie': 'In einem deiner Objekte wird ein Vorfall eröffnet',
    'aviso.RESPUESTA_EQUIPO': 'Antwort des Teams',
    'aviso.RESPUESTA_EQUIPOPie': 'Wir antworten im Gespräch zu einem Vorfall',
    'aviso.ESTANCIA_NUEVA': 'Aufenthalt eingetragen',
    'aviso.ESTANCIA_NUEVAPie': 'Für das Objekt wird ein Aufenthalt notiert',
    'aviso.GASTO_ALTOPie': 'Eine Ausgabe über 100 €, samt wer sie erfasst hat',
    'aviso.ASIGNADA_A_TI': 'Dir wird ein Vorgang zugewiesen',
    'aviso.ASIGNADA_A_TIPie': 'Wenn du für die Lösung verantwortlich gemacht wirst',
    'aviso.INCIDENCIA_CRITICA': 'Kritische Vorfälle',
    'aviso.INCIDENCIA_CRITICAPie': 'Wenn ein Vorfall höchster Dringlichkeit eingeht (S1 oder S2)',
    'aviso.VISITA_VENCIDA': 'Überfällige Besuche',
    'aviso.VISITA_VENCIDAPie': 'Ein geplanter Besuch, dessen Termin verstrichen ist',
    'aviso.GASTO_PENDIENTE': 'Zu genehmigende Ausgaben',
    'aviso.GASTO_PENDIENTEPie': 'Erfasste Ausgaben, die auf deine Entscheidung warten',
    'aviso.PAGO_RECURRENTE': 'Wiederkehrende Zahlungen',
    'aviso.PAGO_RECURRENTEPie': 'Beiträge und Zahlungen, die jeden Monat wiederkehren',
    'aviso.FACTURA_VENCIDA': 'Überfällige Rechnungen',
    'aviso.FACTURA_VENCIDAPie': 'Ausgestellte Rechnungen, die noch offen sind',
    'aviso.MANTENIMIENTO_VENCIDO': 'Überfällige Wartung',
    'aviso.MANTENIMIENTO_VENCIDOPie': 'Wartungen, deren Termin verstrichen ist',
    'aj.faceId': 'Registrierte Passkeys',
    'aj.faceIdPie': 'Du meldest dich mit E-Mail und Passwort an, und der Browser füllt beides für dich aus. Hier stehen die Passkeys, die du früher registriert hast: Sie öffnen keine Sitzung mehr, und du kannst sie jederzeit entfernen.',
    'aj.dispositivo': 'Gerät',
    'aj.anadida': 'Hinzugefügt',
    'aj.ultimoUso': 'Zuletzt verwendet',
    'aj.enLlavero': 'in deinem Schlüsselbund',
    'aj.sinLlaves': 'Du hast keine registrierten Passkeys.',
    'aj.porQueQuitas': 'Warum entfernst du „{nombre}“?',
    'aj.motivoLlave': 'Ich benutze dieses Gerät nicht mehr',
    'aj.llaveRetirada': 'Passkey entfernt.',
    'aj.segundoFactor': 'Zweiter Faktor',
    'aj.activo': 'Aktiv',
    'aj.inactivo': 'Inaktiv',
    'aj.dosFactoresActivo': 'Dein Konto verlangt zusätzlich zum Passwort einen Code.',
    'aj.dosFactoresInactivo': 'Füge deinem Zugang eine weitere Ebene hinzu.',
    'aj.activarDosFactores': 'Zweiten Faktor aktivieren',
    'aj.codigoDesactivar': 'Code zum Deaktivieren',
    'aj.desactivar': 'Deaktivieren',
    'aj.codigoConfirmar': 'Bestätigungscode',
    'aj.confirmar': 'Bestätigen',
    'aj.escanea': 'Scanne ihn in deiner Authenticator-App (Google Authenticator, 1Password…) oder gib das Geheimnis von Hand ein. Bestätige dann mit dem Code.',
    'aj.secreto': 'Geheimnis',
    'aj.password': 'Dein Passwort',
    'aj.passwordPie': 'Das aktuelle Passwort wird abgefragt, weil eine offene Sitzung an einem geliehenen Rechner nicht ausreichen darf, um dich aus deinem Konto auszusperren.',
    'aj.passwordActual': 'Aktuelles Passwort',
    'aj.passwordNueva': 'Neues Passwort',
    'aj.passwordRepetir': 'Neues Passwort wiederholen',
    'aj.passwordCambiar': 'Passwort ändern',
    'aj.passwordCambiada': 'Passwort geändert.',
    'aj.passwordNoCoincide': 'Die beiden neuen Passwörter stimmen nicht überein.',
    'aj.passwordMinimo': 'Mindestens 8 Zeichen.',
    'auth.passwordCorta': 'Das neue Passwort ist zu kurz.',
    'auth.passwordIgual': 'Das neue Passwort entspricht dem aktuellen.',
    'auth.passwordActualMal': 'Das aktuelle Passwort ist nicht korrekt.',
    'aj.guardar': 'Speichern',
    'aj.guardando': 'Wird gespeichert…',
    'aj.guardado': 'Gespeichert.',
    'aj.noSeCargo': 'Konnte nicht geladen werden.',
    'aj.noSeGuardo': 'Konnte nicht gespeichert werden.',
    'aj.empresa': 'Unternehmen',
    'portal.notificarIncidencia': 'Neuen Vorfall melden',
    'portal.notificarVisita': 'Aufenthalt melden',
    'portal.ultimaVisita': 'Letzter Besuch',
    'portal.proximaVisitaCorta': 'Nächster Besuch',
    'portal.sinVisitas': 'Noch keine Besuche',
    'portal.urgencia': 'Wie dringend ist es?',
    'portal.urgenciaPie': 'Sag uns, wie du es einschätzt. Das Team prüft es und kann es anpassen.',
    'portal.anadirFotos': 'Fotos hinzufügen',
    'portal.cancelar': 'Abbrechen',
    'portal.tituloIncidencia': 'Titel',
    'portal.editarPie': 'Titel und Beschreibung kannst du ändern, solange der Vorfall offen ist.',
    'portal.noSeGuardo': 'Die Änderung konnte nicht gespeichert werden.',
    'portal.noSeSubio': 'Das Foto konnte nicht hochgeladen werden.',
    'visor.cerrar': 'Schließen',
    'visor.abrirFuera': 'Separat öffnen',
    'visor.cargando': 'Wird geöffnet…',
    'visor.noSePudo': 'Die Datei konnte nicht geöffnet werden.',
    'visor.noSeVePreview': 'Diese Datei kann hier nicht angezeigt werden. Separat öffnen, um sie herunterzuladen.',
    'roto.titulo': 'Diese Ansicht konnte nicht gezeichnet werden',
    'roto.explicacion': 'Der Rest der Anwendung funktioniert weiter. Kopieren Sie diese Details und senden Sie sie: Sie sagen genau, was fehlgeschlagen ist.',
    'roto.copiar': 'Details kopieren',
    'roto.volver': 'Zurück zur Übersicht',
    'app.volver': 'Zurück',
    'app.editar': 'Bearbeiten',
    'app.confirmar': 'Bestätigen',
    'app.consecuencias': 'Bitte vor dem Bestätigen lesen, was das bedeutet:',
    'auth.titulo': 'Anmelden',
    'auth.email': 'E-Mail-Adresse',
    'auth.password': 'Passwort',
    'auth.entrar': 'Anmelden',
    'nav.ajustes': 'Einstellungen',
    'nav.propiedades': 'Objekte',
    'nav.panel': 'Übersicht',
    'integraciones.nota': 'Schlüssel werden beim Speichern verschlüsselt und nie wieder angezeigt: Hier siehst du nur, ob ein Dienst verbunden ist.',
    'integraciones.conectada': 'Verbunden',
    'integraciones.sinConectar': 'Nicht verbunden',
    'integraciones.cambiar': 'Schlüssel ersetzen',
    'integraciones.configurar': 'Einrichten',
    'integraciones.desconectar': 'Trennen',
    'integraciones.clave': 'Schlüssel / Token (geheim)',
    'integraciones.clavePista': 'Wird beim Speichern verschlüsselt; nie wieder angezeigt',
    'integraciones.etiqueta': 'Bezeichnung (optional)',
    'nav.mas': 'Mehr',
    'auth.salir': 'Abmelden',
    'auth.error.credenciales': 'E-Mail oder Passwort ist nicht korrekt.',
    'auth.error.demasiadosIntentos': 'Zu viele Versuche hintereinander. Warte ein paar Minuten und versuche es erneut.',
    'auth.error.sesionExpirada': 'Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.',
    'auth.error.segundoFactor': 'Der Bestätigungscode ist nicht korrekt.',
    'error.sinPermiso': 'Sie haben keine Berechtigung, dies anzusehen.',
    'error.gastoFacturado': 'Diese Ausgabe steht bereits auf einer Rechnung: Sie kann weder geändert noch entfernt werden. Korrigieren Sie stattdessen die Rechnung.',
    'error.responsableNoValido': 'Diese Person kann das nicht übernehmen: Sie muss ein aktives Teammitglied sein.',
    'error.responsableSinAcceso': 'Dieser Person ist diese Immobilie nicht zugewiesen. Weisen Sie sie unter Benutzer zu und versuchen Sie es erneut.',
    'inc.responsable': 'Verantwortlich',
    'inc.titulo': 'Titel',
    'inc.descripcion': 'Beschreibung',
    'inc.sinResponsable': 'Ohne Verantwortlichen',
    'inc.elegirResponsable': 'Verantwortlichen wählen…',
    'inc.responsableNota': 'Erscheint in deren „Aufgaben des Tages“, solange der Vorgang offen ist.',
    'inc.sinAccesoCasa': 'kein Zugriff auf diese Immobilie',
    'dia.asignada': 'Zugewiesen',
    'error.noEncontrado': 'Nicht gefunden.',
    'error.validacion': 'Bitte prüfen Sie Ihre Eingaben.',
    'error.servidor': 'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
    'error.configuracion': 'Diese Funktion ist noch nicht konfiguriert.',
    'referido.estadoInvalido': 'Die Empfehlung lässt diese Aktion in ihrem Status nicht zu.',
    'propiedades.titulo': 'Immobilien',
    'propiedades.vacio': 'Noch keine Immobilien vorhanden.',
    'propiedades.codigo': 'Code',
    'propiedades.nombre': 'Name',
    'propiedades.zona': 'Gebiet',
    'propiedades.estado': 'Status',
    'propiedades.propietarios': 'Eigentümer',
    'propiedades.nio': 'Serviceniveau',
    'propiedades.semaforo': 'Betriebsstatus',
    'propiedades.requisitos': 'Offene Voraussetzungen',
    'propiedades.sinRequisitos': 'Bereit zur Aktivierung',
    'propiedades.impideActivacion': 'Das fehlt noch für die Aktivierung:',
    'propiedades.activar': 'Immobilie aktivieren',
    'propiedades.demoExcluida': 'von Kennzahlen und jedem echten Vorgang ausgeschlossen.',
    'propiedades.historial': 'Verlauf',
    'propiedades.relaciones': 'Personen und Unternehmen',
    'propiedades.contrato': 'Vertrag',
    'propiedades.incidencias': 'Vorgänge',
    'cartera.resumen': '{total} insgesamt · {atencion} brauchen Aufmerksamkeit',
    'cartera.buscar': 'Nach Code, Name oder Gebiet suchen',
    'cartera.ordenar': 'Sortieren',
    'cartera.ordenEstado': 'Nach Status',
    'cartera.ordenNombre': 'Nach Name',
    'cartera.ordenCodigo': 'Nach Code',
    'cartera.verLista': 'Listenansicht',
    'cartera.verTarjetas': 'Kartenansicht',
    'cartera.sinTitular': 'Noch kein Eigentümer',
    'cartera.sinResultados': 'Keine Immobilien entsprechen der Suche.',
    'cartera.limpiar': 'Suche zurücksetzen',
    'cartera.activas': '{total} aktiv',
    'cartera.incidenciasAbiertas': 'Offene Vorfälle',
    'cartera.nueva': 'Neue Immobilie',
    'proveedores.titulo': 'Dienstleister',
    'proveedores.resumen': '{total} aktiv',
    'proveedores.nuevo': 'Neuer Dienstleister',
    'proveedores.vacio': 'Noch keine Dienstleister im Verzeichnis.',
    'proveedores.nombre': 'Name',
    'proveedores.oficio': 'Gewerk',
    'proveedores.email': 'E-Mail',
    'proveedores.telefono': 'Telefon',
    'proveedores.nif': 'Steuer-ID',
    'proveedores.zona': 'Gebiet',
    'proveedores.notas': 'Notizen',
    'proveedores.guardar': 'Dienstleister speichern',
    'proveedores.cancelar': 'Abbrechen',
    'proveedores.archivar': 'Archivieren',
    'proveedores.reactivar': 'Reaktivieren',
    'proveedores.archivado': 'Archiviert',
    'proveedores.verArchivados': 'Archivierte anzeigen',
    'proveedores.todos': 'Alle Gewerke',
    'proveedores.sinContacto': 'Kein Kontakt',
    'oficio.FONTANERIA': 'Sanitär',
    'oficio.JARDINERIA': 'Garten',
    'oficio.CLIMA': 'Klimatechnik',
    'oficio.PISCINAS': 'Pools',
    'oficio.LIMPIEZA': 'Reinigung',
    'oficio.ELECTRICIDAD': 'Elektrik',
    'oficio.OBRA': 'Bauarbeiten',
    'oficio.SEGURIDAD': 'Sicherheit',
    'oficio.OTRO': 'Sonstiges',
    'calendario.titulo': 'Kalender',
    'calendario.mes': 'Monat',
    'calendario.anterior': 'Voriger Monat',
    'calendario.siguiente': 'Nächster Monat',
    'calendario.hoy': 'Heute',
    'calendario.todas': 'Alle Immobilien',
    'calendario.nuevo': 'Neuer Termin',
    'calendario.sinEventos': 'Keine Termine in diesem Monat.',
    'calendario.mas': '+{total} mehr',
    'evento.VISITA': 'Besuch',
    'evento.PREVENTIVA': 'Wartung',
    'evento.REVISION': 'Prüfung',
    'evento.LLEGADA': 'Anreise',
    'evento.SALIDA': 'Abreise',
    'evento.OTRO': 'Sonstiges',
    'evento.tipo': 'Art',
    'evento.titulo': 'Titel',
    'evento.fecha': 'Datum',
    'evento.hora': 'Uhrzeit',
    'evento.propiedad': 'Immobilie',
    'evento.asignado': 'Zugewiesen an',
    'evento.notas': 'Notizen',
    'evento.sinPropiedad': 'Keine Immobilie',
    'evento.sinAsignar': 'Nicht zugewiesen',
    'evento.guardar': 'Termin speichern',
    'evento.marcarHecha': 'Als erledigt markieren',
    'evento.marcarCancelada': 'Termin absagen',
    'evento.reabrir': 'Wieder öffnen',
    'evento.cerrar': 'Schließen',
    'evento.irPropiedad': 'Immobilie öffnen',
    'checklists.titulo': 'Checklisten-Vorlagen',
    'checklists.resumen': '{total} Vorlagen',
    'checklists.nuevaPlantilla': 'Neue Vorlage',
    'checklists.sinPlantillas': 'Noch keine Vorlagen.',
    'checklists.elige': 'Wähle eine Vorlage, um ihre Punkte zu sehen.',
    'checklists.itemsCorto': 'Punkte',
    'checklists.criticos': 'Kritisch',
    'checklists.critico': 'Kritisch',
    'checklists.foto': 'Foto',
    'checklists.anadirItem': 'Punkt hinzufügen',
    'checklists.seccion': 'Abschnitt',
    'checklists.texto': 'Text des Punkts',
    'checklists.guardar': 'Speichern',
    'checklists.cancelar': 'Abbrechen',
    'checklists.archivar': 'Archivieren',
    'checklists.reactivar': 'Reaktivieren',
    'checklists.archivada': 'Archiviert',
    'checklists.eliminar': 'Löschen',
    'checklists.editar': 'Bearbeiten',
    'checklists.nombre': 'Name',
    'checklists.tipo': 'Art',
    'checklists.sinItems': 'Diese Vorlage hat noch keine Punkte.',
    'checklistTipo.ENTRADA': 'Check-in',
    'checklistTipo.SALIDA': 'Check-out',
    'checklistTipo.PERIODICA': 'Regelmäßige Prüfung',
    'checklistTipo.MANTENIMIENTO': 'Wartung',
    'checklistTipo.OTRO': 'Sonstiges',
    'alertas.titulo': 'Benachrichtigungen',
    'alertas.marcarLeidas': 'Als gelesen markieren',
    'alertas.sinLeer': '{total} ungesehen',
    'alertas.resumen': '{total} brauchen deine Aufmerksamkeit',
    'alertas.vacio': 'Alles erledigt. Keine Warnungen.',
    'alertas.incidencia': 'Offener Vorfall',
    'alertas.activacion': 'Aktivierung ausstehend',
    'alertas.requisitos': '{total} Anforderungen offen',
    'alertaSeveridad.ALTA': 'Hoch',
    'alertaSeveridad.MEDIA': 'Mittel',
    'alertaSeveridad.BAJA': 'Niedrig',
    'mapa.titulo': 'Aktivitätskarte',
    'mapa.subtitulo': 'Wo das Portfolio liegt und was Aufmerksamkeit braucht',
    'mapa.zona': 'Gebiet',
    'mapa.todas': 'Alle Gebiete',
    'mapa.esquema': 'Illustratives Schema: die Positionen sind nicht geografisch.',
    'mapa.actividad': 'Immobilien mit offenen Vorfällen',
    'mapa.sinActividad': 'Keine offenen Vorfälle in dieser Auswahl.',
    'mapa.incidencias': '{total} offen',
    'adjunto.noSeGuarda': 'Die Datei konnte auf dem Server nicht gespeichert werden.',
    'ficha.subiendoFoto': 'Foto wird hochgeladen...',
    'ficha.subirFoto': 'Foto auswaehlen (JPEG, PNG oder WEBP)',
    'ficha.subirFotoAyuda': 'Wird im System gespeichert. Beim Entfernen wird auch die Datei geloescht.',
    'ficha.anadirPorUrl': 'Per Adresse hinzufuegen',
    'cobro.titulo': 'Zahlung',
    'cobro.POR_COBRAR': 'Offen',
    'cobro.FACTURADO': 'Berechnet',
    'cobro.COBRADO': 'Bezahlt',
    'adjunto.contenidoPerdido': 'Die Datei liegt nicht mehr im Speicher.',
    'inc.fotoNoSeVe': 'Kann nicht angezeigt werden. Oeffnen oder herunterladen',
    'interno.buscar': 'Vorgang, Person oder Beschreibung suchen',
    'interno.todoElEquipo': 'Ganzes Team',
    'interno.todoElHistorico': 'Gesamter Zeitraum',
    'interno.meses': 'Monate',
    'interno.limpiar': 'Filter entfernen',
    'interno.importeDesde': 'Betrag ab',
    'interno.importeHasta': 'Betrag bis',
    'interno.descargarExcel': 'Excel herunterladen',
    'interno.horasTitulo': 'Stunden des Teams',
    'llaves.noEntra': 'Anmeldung mit dem Schluessel nicht moeglich. Versuche es mit dem Passwort.',
    'llaves.desafioInvalido': 'Die Anfrage ist abgelaufen. Bitte erneut versuchen.',
    'llaves.noVerificada': 'Der Schluessel konnte nicht geprueft werden.',
    'llaves.desconocida': 'Dieser Schluessel ist nicht registriert.',
    'llaves.clonada': 'Der Schluessel besteht die Sicherheitspruefung nicht. Entferne ihn und lege einen neuen an.',
    'import.carteraConDatos': 'Das Portfolio hat bereits Objekte: die Startaufnahme wird nur einmal eingespielt, und das ist geschehen.',
    'import.checkTitulo': 'Checklisten-Vorlagen',
    'import.checkIntro': 'Holt die Besuchsvorlagen aus dem alten System. Sie werden am Namen erkannt: ein erneuter Lauf ergänzt nur fehlende Punkte.',
    'import.checkPlantillas': 'Vorlagen',
    'import.checkItems': 'Punkte',
    'import.proyTitulo': 'Projekte und Aufgaben',
    'import.proyIntro': 'Holt die Projekte aus dem vorherigen Werkzeug. Mehrfach ausführbar: Vorhandenes wird erkannt, nicht dupliziert.',
    'import.proyEquipos': 'Teams',
    'import.proyProyectos': 'Projekte',
    'import.proySecciones': 'Abschnitte',
    'import.proyTareas': 'Aufgaben',
    'import.proySubtareas': 'Teilaufgaben',
    'import.proyAsignaciones': 'Zugewiesene Verantwortliche',
    'import.proyEtiquetas': 'Etiketten',
    'import.proyYaEstaban': 'Bereits vorhanden (nicht dupliziert)',
    'import.proySinResolver': 'Personen aus der Datei, die nicht im Team sind',
    'import.titulo': 'Startdaten importieren',
    'import.intro': 'Bringt auf einen Schlag die Geschichte herein, die das Unternehmen schon hatte: Haeuser, Vorfaelle, Ausgaben und die Stunden des Teams. Nur bei leerem Bestand moeglich, und es kommt entweder alles an oder nichts.',
    'import.fichero': 'Datei mit der Momentaufnahme (.json)',
    'import.password': 'Erstes Passwort fuer das Team',
    'import.passwordNota': 'Wird an die hier angelegten Personen gegeben. Jede aendert es beim ersten Anmelden; die Leitung kann es unter Benutzer zuruecksetzen.',
    'import.importar': 'Importieren',
    'import.importando': 'Import laeuft…',
    'import.hecho': 'Daten importiert',
    'import.ficheroInvalido': 'Diese Datei ist keine gueltige Momentaufnahme.',
    'import.deshabilitada': 'Der Import ist in dieser Installation nicht aktiviert.',
    'import.carteraNoVacia': 'Der Bestand enthaelt bereits Objekte: ein Import wuerde sie verdoppeln.',
    'import.usuariosCreados': 'Angelegte Personen',
    'import.usuariosReutilizados': 'Bereits vorhandene Personen',
    'import.propiedades': 'Objekte',
    'import.proveedores': 'Lieferanten',
    'import.gastos': 'Ausgaben',
    'import.horas': 'Stunden',
    'import.incidencias': 'Vorfaelle',
    'import.eventos': 'Kalendereintraege',
    'import.mantenimiento': 'Wartungen',
    'import.estancias': 'Aufenthalte',
    'import.documentos': 'Dokumente',
    'import.historial': 'Verlaufseintraege',
    'area.INTERIOR': 'Innen',
    'area.EXTERIOR': 'Aussen',
    'area.SISTEMAS': 'Technik',
    'area.PISCINA': 'Pool',
    'area.JARDIN': 'Garten',
    'area.GESTION': 'Verwaltung',
    'area.OTRO': 'Andere',
    'prov.hola': 'Hallo, {nombre}',
    'prov.misEncargos': 'Meine Auftraege',
    'prov.resumen': '{total} offene Auftraege',
    'prov.sinEncargos': 'Du hast keine offenen Auftraege.',
    'prov.historico': 'Abgeschlossen ({total})',
    'prov.instrucciones': 'Anweisungen',
    'prov.aceptar': 'Auftrag annehmen',
    'prov.rechazar': 'Ablehnen',
    'prov.iniciar': 'Arbeit beginnen',
    'prov.solicitarFin': 'Abnahme anfordern',
    'prov.esperandoCierre': 'Wartet auf Abnahme',
    'prov.presupuestar': 'Angebot',
    'prov.enviarPresupuesto': 'Angebot senden',
    'prov.tuPresupuesto': 'Dein Angebot',
    'prov.queIncluye': 'Was enthalten ist',
    'prov.porQue': 'Warum lehnst du ab?',
    'prov.porQueNota': 'Ohne Begruendung muesste das Team anrufen, um zu erfahren, was los ist.',
    'prov.motivoRechazo': 'Grund der Ablehnung',
    'encargo.ASIGNADO': 'Zugewiesen',
    'encargo.ACEPTADO': 'Angenommen',
    'encargo.EN_CURSO': 'In Arbeit',
    'encargo.FIN_SOLICITADA': 'Abnahme angefordert',
    'encargo.COMPLETADO': 'Abgeschlossen',
    'encargo.RECHAZADO': 'Abgelehnt',
    'encargo.sinProveedor': 'Dein Benutzer ist keinem Lieferanten zugeordnet.',
    'encargo.estadoInvalido': 'Der Auftrag erlaubt diese Aktion in seinem Status nicht.',
    'encargo.proveedorInactivo': 'Dieser Lieferant ist archiviert.',
    'encargo.encargar': 'An einen Lieferanten vergeben',
    'encargo.encargos': 'Auftraege',
    'proyecto.sinMiembros': 'Noch ist niemand in diesem Projekt.',
    'proyecto.sinCandidatos': 'Niemand aus dem Team bleibt zum Hinzufuegen.',
    'proyecto.responsable': 'Verantwortlich',
    'equipo.vincularPropiedad': 'Objekt verknuepfen',
    'equipo.titulo': 'Benutzer',
    'equipo.resumen': '{total} Benutzer im System',
    'equipo.nuevo': 'Neuer Benutzer',
    'equipo.crear': 'Benutzer anlegen',
    'equipo.buscar': 'Nach Name oder E-Mail suchen...',
    'equipo.sinResultados': 'Niemand passt zu dieser Suche.',
    'equipo.filtroTODOS': 'Alle',
    'equipo.filtroEQUIPO': 'Team',
    'equipo.filtroCLIENTES': 'Kunden',
    'equipo.filtroOCULTOS': 'Ausgeblendet',
    'equipo.nProp': '{total} Obj.',
    'equipo.oculto': 'Ausgeblendet',
    'equipo.activo': 'Aktiv',
    'equipo.informacion': 'Information',
    'equipo.propiedades': 'Objekte',
    'equipo.nombreCompleto': 'Vollstaendiger Name',
    'equipo.nombrePista': 'z. B. Manuel Garcia',
    'equipo.claveInicial': 'Erstes Passwort',
    'equipo.claveMinimo': 'Mindestens 8 Zeichen',
    'equipo.claveNueva': 'Neues Passwort (min. 8)',
    'equipo.idioma': 'Sprache',
    'equipo.rolSistema': 'Systemrolle',
    'equipo.rolAyuda': 'Bestimmt, welche Daten erreichbar sind. Nicht das Gewerk.',
    'equipo.rolInmediato': 'Die Rollenaenderung wirkt sofort: die Person muss sich neu anmelden.',
    'equipo.accesoCrm': 'CRM-Zugang',
    'equipo.accesoCrmAyuda': 'Das CRM zeigt, mit wem gesprochen wird, über welchen Betrag und in welcher Phase. Wird einzeln vergeben.',
    'equipo.crmSi': 'Mit Zugang',
    'equipo.crmNo': 'Ohne Zugang',
    'equipo.funcion': 'Funktion im Unternehmen',
    'equipo.funcionAyuda': 'Womit sich die Person beschaeftigt. Aendert nicht, was sie sieht.',
    'equipo.guardarCambios': 'Aenderungen speichern',
    'equipo.guardar': 'Speichern',
    'equipo.guardado': 'Gespeichert.',
    'equipo.restablecerClave': 'Passwort zuruecksetzen',
    'equipo.claveCambiada': 'Passwort geaendert.',
    'equipo.claveCierraSesiones': 'Damit werden alle offenen Sitzungen geschlossen.',
    'equipo.ocultarUsuario': 'Benutzer ausblenden',
    'equipo.eliminarUsuario': 'Benutzer loeschen',
    'equipo.reactivar': 'Benutzer reaktivieren',
    'equipo.tieneHistoricoNota': 'Diese Person hat bereits Arbeit erfasst und wird daher nicht geloescht: sie wird ausgeblendet und ihre Historie bleibt.',
    'equipo.sinHistoricoNota': 'Sie hat nie Arbeit erfasst und kann geloescht werden, ohne etwas zu verwaisen.',
    'equipo.sinPropiedades': 'Keine Objekte zugeordnet.',
    'equipo.asignarPropiedad': 'Objekt zuordnen',
    'equipo.buscarPropiedad': 'Nach Name oder Code suchen...',
    'equipo.sinCandidatas': 'Es bleibt kein Objekt zum Zuordnen.',
    'equipo.rolEnPropiedad': 'Rolle im Objekt',
    'equipo.retirar': 'Entfernen',
    'equipo.emailDuplicado': 'Diese E-Mail wird bereits verwendet.',
    'equipo.ultimoDirector': 'Das Unternehmen bliebe ohne Leitung.',
    'equipo.noATiMismo': 'Das kannst du nicht mit dir selbst machen.',
    'equipo.tieneHistorico': 'Diese Person hat bereits Arbeit erfasst: sie wird ausgeblendet, nicht geloescht.',
    'equipo.clienteVaPorParty': 'Ein Eigentuemer wird ueber seinen Personendatensatz mit dem Objekt verknuepft, denn darauf beruht die Abrechnung.',
    'equipo.inactivo': 'Diese Person ist deaktiviert.',
    'asignacion.PRINCIPAL': 'Hauptverantwortlich',
    'asignacion.SECUNDARIO': 'Unterstuetzend',
    'asignacion.OWNER': 'Eigentuemer',
    'asignacion.PROMOTER': 'Bautraeger',
    'asignacion.ASSET_MANAGER': 'Asset Manager',
    'asignacion.AUTHORIZED_CONTACT': 'Bevollmaechtigter Kontakt',
    'funcion.DIRECCION': 'Leitung',
    'funcion.MANAGER': 'Manager',
    'funcion.MARKETING': 'Marketing',
    'funcion.REAL_ESTATE': 'Real Estate',
    'funcion.MANTENIMIENTO': 'Instandhaltung',
    'funcion.JARDINERIA': 'Gartenpflege',
    'funcion.LIMPIEZA': 'Reinigung',
    'funcion.ADMINISTRACION': 'Verwaltung',
    'funcion.OTRA': 'Andere',
    'proyecto.soloEquipo': 'In ein internes Projekt kommt nur das Team.',
    'proyecto.miembros': 'Mitglieder',
    'proyecto.anadirMiembro': 'Zum Projekt hinzufuegen',
    'contacto.intro': 'Wie du uns erreichst und die haeufigsten Fragen.',
    'contacto.comoEscribir': 'Wie du uns schreibst',
    'contacto.reportarPie': 'Aus deinem Portal. Wir sehen es am selben Tag und nennen dir die Dringlichkeit.',
    'contacto.responderHilo': 'Im Vorgang antworten',
    'contacto.responderHiloPie': 'Oeffne einen Vorgang und schreibe: die Nachricht erreicht die zustaendige Person.',
    'contacto.faq': 'Haeufige Fragen',
    'contacto.p.semaforo': 'Was bedeutet der Status meines Objekts?',
    'contacto.r.semaforo': 'Gruen heisst, alles ist aktuell. Gelb heisst, es ist etwas offen, aber nicht dringend. Rot heisst, etwas braucht jetzt Aufmerksamkeit, und dann sind wir bereits dran.',
    'contacto.p.idiomaClave': 'Wie aendere ich Sprache oder Passwort?',
    'contacto.r.idiomaClave': 'Die Sprache aenderst du jederzeit unten links. Das Passwort aenderst du in den Einstellungen.',
    'contacto.p.reportar': 'Wie melde ich etwas?',
    'contacto.r.reportar': 'Mit dem Melden-Knopf in deinem Portal. Beschreibe es mit deinen Worten: die technische Dringlichkeit setzen wir bei der Pruefung.',
    'contacto.p.informe': 'Wo sehe ich, was in meinem Haus gemacht wurde?',
    'contacto.r.informe': 'Unter Meine Vorgaenge findest du jede Massnahme mit Fotos und Konversation. Dort erscheint, was das Team mit dir geteilt hat.',
    'cartera.resumenAsignadas': '{total} zugeordnet · {atencion} brauchen Aufmerksamkeit',
    'panel.miPanel': 'Mein Panel',
    'portal.buenosDias': 'Guten Morgen, {nombre}',
    'portal.buenasTardes': 'Guten Tag, {nombre}',
    'portal.buenasNoches': 'Guten Abend, {nombre}',
    'portal.tusPropiedades': 'Deine Objekte',
    'portal.misPropiedades': 'Meine Objekte',
    'portal.sinPropiedades': 'Dir ist noch kein Objekt zugeordnet.',
    'portal.visitasAnio': 'Besuche dieses Jahr',
    'portal.incidenciasAbiertas': 'Offene Vorgaenge',
    'portal.enCurso': 'in Bearbeitung',
    'portal.alCorriente': 'Zahlungen aktuell',
    'portal.proximaVisita': 'Dein naechster Besuch: {fecha}',
    'portal.misIncidencias': 'Meine Vorgaenge',
    'portal.sinIncidencias': 'Aktuell ist nichts offen.',
    'portal.filtroABIERTAS': 'Offen',
    'portal.filtroRESUELTAS': 'Erledigt',
    'portal.filtroTODAS': 'Alle',
    'portal.sinEnEsteFiltro': 'Hier ist nichts.',
    'portal.abierta': 'Offen',
    'portal.resuelta': 'Erledigt',
    'portal.resumen': 'Zusammenfassung zu Ihrem Objekt',
    'portal.resumenPie': 'Automatisch aus den Daten dieser Seite erstellt.',
    'portal.resumenNoDisponible': 'Die automatische Zusammenfassung ist gerade nicht verfügbar.',
    'portal.fotos': 'Fotos',
    'portal.mensajes': 'Nachrichten',
    'portal.sinMensajes': 'Noch keine Nachrichten. Schreib uns bei Fragen.',
    'portal.escribeMensaje': 'Nachricht schreiben...',
    'portal.enviar': 'Senden',
    'portal.tuEstancia': 'Dein Aufenthalt',
    'portal.sinEstancias': 'Es wurde kein Aufenthalt gemeldet.',
    'portal.avisarLlegada': 'Ankunft melden',
    'portal.llegada': 'Ankunft',
    'portal.salida': 'Abreise (optional)',
    'portal.estanciaNota': 'So planen wir keinen Besuch, waehrend du im Haus bist.',
    'portal.reportar': 'Vorgang melden',
    'portal.queOcurre': 'Was ist passiert?',
    'portal.queOcurrePista': 'Zum Beispiel: der Kuechenhahn tropft',
    'portal.detalles': 'Details (optional)',
    'portal.reportarNota': 'Wir pruefen es und melden Dringlichkeit und naechste Schritte.',
    'portal.facturacion': 'Rechnungsdaten',
    'portal.documentos': 'Unterlagen deines Hauses',
    'portal.sinDocumentos': 'Noch keine geteilten Unterlagen.',
    'ficha.verDueno': 'Eigentümer sieht es',
    'portal.facturacionPie': 'Ergaenze deine Daten, damit sie auf der Rechnung erscheinen.',
    'portal.facturacionCampo': 'Name, Steuernummer und Anschrift',
    'portal.facturacionPista': 'Name oder Firma\nSteuernummer\nVollstaendige Anschrift',
    'portal.editar': 'Bearbeiten',
    'portal.guardar': 'Speichern',
    'portal.contacto': 'Kontakt',
    'portal.ajustes': 'Einstellungen',
    'rapido.fecha': 'Datum',
    'rapido.importe': 'Betrag',
    'rapido.queEs': 'Was',
    'rapido.titulo': 'Was moechtest du erfassen?',
    'rapido.gasto': 'Eine Ausgabe',
    'rapido.horas': 'Arbeitsstunden',
    'rapido.horasPie': 'Aufgewendete Zeit',
    'rapido.comprobante': 'Beleg',
    'rapido.fotoObligatoria': 'Ein Foto des Belegs ist Pflicht: ohne das laesst sich die Ausgabe nicht belegen.',
    'rapido.hacerFoto': 'Foto aufnehmen oder Datei waehlen',
    'rapido.formatosFoto': 'Bild oder PDF',
    'rapido.deQuienSon': 'Wessen Arbeit ist das?',
    'rapido.deQuienSonPie': 'Die Leitung kann Arbeit fuer Personen erfassen, die die App nicht nutzen.',
    'rapido.mias': 'Meine',
    'rapido.paraQuien': 'Fuer wen ist es?',
    'rapido.cliente': 'Fuer einen Kunden',
    'rapido.clientePie': 'Geht an ein Objekt',
    'rapido.interno': 'Intern',
    'rapido.internoPie': 'Firma, ohne Objekt',
    'rapido.queCliente': 'Welches Objekt?',
    'rapido.vinculado': 'Gehoert es zu einem offenen Vorgang?',
    'rapido.aislado': 'Ohne Vorgang',
    'error.gastoDeHoras': 'Diese Zeile stammt aus erfassten Stunden: Stunden und Sätze werden über „Bearbeiten“ bei den Stunden korrigiert; hier ändert sich nur die Beschreibung.',
    'categoriaGasto.MANO_DE_OBRA': 'Arbeitsleistung',
    'rapido.otraPersona': 'Andere: Namen eingeben',
    'rapido.otraPersonaPie': 'Ein Lieferant oder jemand ohne App-Zugang',
    'rapido.nombrePersona': 'Name der Person oder des Lieferanten',
    'rapido.vinculadoPie': 'Einen oder mehrere markieren, eine Beschreibung hinzufügen oder beides.',
    'rapido.descripcionManual': 'Manuelle Beschreibung',
    'rapido.descripcionManualPie': 'Schreiben, was gemacht wurde',
    'rapido.queSeHizo': 'Was wurde gemacht?',
    'rapido.continuar': 'Weiter',
    'rapido.costeYPrecio': 'Kosten und Preis pro Stunde',
    'rapido.costeYPrecioPie': 'Aus den Teamsätzen übernommen. Nur für diesen Auftrag änderbar.',
    'rapido.costeHora': 'Kosten pro Stunde (€)',
    'rapido.precioHora': 'Preis pro Stunde für den Kunden (€)',
    'rapido.facturableExtra': 'Extra abrechenbar?',
    'rapido.extraSi': 'Erscheint in den Ausgaben des Objekts und wird dem Kunden berechnet',
    'rapido.extraNo': 'Interne Kosten: in der Gebühr enthalten, der Kunde sieht 0 €',
    'rapido.costeHoraInvalido': 'Kosten pro Stunde angeben (kann 0 sein).',
    'rapido.precioHoraInvalido': 'Um es separat zu berechnen, den Stundenpreis für den Kunden angeben.',
    'gastos.descripcion': 'Beschreibung',
    'gastos.descripcionPlaceholder': 'Was wurde gemacht…',
    'gastos.incidencias': 'Zugehörige Vorgänge',
    'gastos.sinIncidenciasAbiertas': 'Dieses Objekt hat keine offenen Vorgänge.',
    'gastos.incluidoEnFee': 'In der Gebühr enthalten',
    'ficha.precioParaCliente': 'Preis für den Kunden',
    'ficha.editarTarifa': 'Satz bearbeiten',
    'ficha.tarifaPrecioPie': 'Auf einen Betrag klicken, um ihn zu ändern. EUR/Stunde und Kundenpreis werden beim Erfassen von Stunden für dieses Objekt vorgeschlagen.',
    'finreg.precioCliente': 'Kundenpreis/Stunde',
    'rapido.queTrabajo': 'Welche Art von Arbeit?',
    'rapido.queTrabajoPie': 'Das entscheidet, wie die Stunden eingeordnet werden.',
    'rapido.queCategoria': 'Welche Art von Ausgabe?',
    'rapido.cuantasHoras': 'Wie lange?',
    'rapido.cuanto': 'Wie viel?',
    'rapido.tiempoManual': 'Oder Zeit eintippen',
    'rapido.tiempoManualPie': 'Erlaubt 45 · 1,5 · 1:45 (Stunden:Minuten)',
    'rapido.tiempoInvalido': 'Diese Zeit ist unklar. Versuche 45, 1,5 oder 1:45 (bis 744 h).',
    'rapido.tiempoEjemplo': '1,45',
    'rapido.importeManual': 'Oder Betrag eintippen',
    'rapido.repercutible': 'Wird es dem Kunden berechnet?',
    'rapido.repercutiblePie': 'Wenn ja, kommt es auf die naechste Rechnung des Objekts.',
    'rapido.entraEnFactura': 'Kommt auf die Rechnung',
    'rapido.loAsumimos': 'Wir tragen es',
    'rapido.si': 'Ja',
    'rapido.no': 'Nein',
    'rapido.cuando': 'Welcher Tag?',
    'rapido.hoy': 'Heute',
    'rapido.ayer': 'Gestern',
    'rapido.fechaInvalida': 'Geben Sie das vollständige Datum ein (Tag, Monat, Jahr). Es darf weder in der Zukunft noch vor 2000 liegen.',
    'rapido.otraFecha': 'Anderes Datum',
    'rapido.revisar': 'Vor dem Senden pruefen',
    'rapido.notaOpcional': 'Notiz (optional)',
    'rapido.enviar': 'Senden',
    'rapido.enviado': 'Erfasst.',
    'rapido.otroMas': 'Weiteres erfassen',
    'rapido.verCargado': 'Zurueck',
    'rapido.atras': 'Zurueck',
    'rapido.confirmar': 'Bestätigen',
    'rapido.toques': 'Schritt {n} von {total}',
    'nav.registrar': 'Erfassen',
    'inc.fotoOcultaAyuda': 'Nur das Team sieht es. Tippen, um es mit dem Eigentuemer zu teilen.',
    'inc.fotoVisibleAyuda': 'Der Eigentuemer sieht es. Tippen, um die Freigabe zu beenden.',
    'factura.titulo': 'Rechnungen',
    'factura.crear': 'Offenes abrechnen',
    'factura.sinFacturas': 'Noch keine Rechnungen.',
    'factura.emitir': 'Ausstellen',
    'factura.cobrar': 'Als bezahlt',
    'factura.vencidaDias': '{total}T überfällig',
    'factura.estadoBORRADOR': 'Entwurf',
    'factura.estadoEMITIDA': 'Ausgestellt',
    'factura.estadoCOBRADA': 'Bezahlt',
    'factura.estadoANULADA': 'Storniert',
    'factura.sinPendiente': 'Keine weiterberechenbaren Ausgaben offen.',
    'factura.estadoInvalido': 'Die Rechnung erlaubt diese Aktion in ihrem Status nicht.',
    'anomalia.titulo': 'Ausgaben-Auffälligkeiten',
    'anomalia.total': '{total} Auffälligkeiten',
    'anomalia.metodo': 'Erkannt mit Median und absoluter Abweichung: eine sehr hohe Ausgabe kann sich nicht selbst verdecken.',
    'severidad.ALTA': 'Hoch',
    'severidad.MEDIA': 'Mittel',
    'severidad.BAJA': 'Niedrig',
    'visita.empezarLista': 'Checkliste starten',
    'visita.continuarLista': 'Checkliste fortsetzen',
    'visita.verLista': 'Checkliste ansehen',
    'visita.desdeAgenda': 'Aus dem Kalender: {titulo}',
    'visita.deLaAgenda': 'Aus dem Kalender',
    'visita.iniciar': 'Besuch starten',
    'visita.plantilla': 'Aus Vorlage',
    'visita.editar': 'Besuch bearbeiten',
    'visita.anadirNota': 'Notiz hinzufügen',
    'visita.motivo': 'Anlass des Besuchs',
    'visita.descartar': 'Verlassen und verwerfen',
    'visita.confirmarDescartar': 'Besuch verlassen, ohne ihn abzuschließen? Das Markierte geht verloren und der Besuch gilt als nicht erfolgt.',
    'visita.enCursoAviso': 'Ein Besuch läuft noch. Öffne ihn, um ihn abzuschließen oder zu verwerfen.',
    'visita.realizadas': 'Durchgeführte Besuche',
    'visita.programadas': 'Geplante Besuche',
    'visita.continuarVisita': 'Besuch fortsetzen',
    'visita.verVisita': 'Besuch ansehen',
    'visita.motivoOpcional': 'Anlass des Besuchs (optional)',
    'visita.motivoPie': 'Warum du hinfährst: was zu prüfen ist, was der Kunde wollte',
    'visita.porMotivo': 'Ohne Liste · aus einem bestimmten Anlass',
    'visita.detalle': 'Detail (optional)',
    'visita.notaPie': 'Was du vorgefunden und getan hast',
    'visita.notaVisita': 'Notiz zum Besuch',
    'visita.quitarFoto': 'Foto entfernen',
    'visita.confirmarQuitarFoto': 'Dieses Foto entfernen? Das lässt sich nicht rückgängig machen.',
    'visita.elegirPlantilla': 'Eine Liste wählen…',
    'visita.resumenPlegado': '{hechos} von {total} Punkten · {fotos} Fotos',
    'visita.plegar': '← Diesen Besuch schließen',
    'evento.sinTitulo': 'Wähle eine Liste für den Besuch.',
    'visita.sinPlantilla': 'Ohne Vorlage (freier Besuch)',
    'visita.copiaNota': 'Die Punkte werden beim Start kopiert: späteres Bearbeiten der Vorlage ändert diesen Besuch nicht.',
    'visita.sinItems': 'Dieser Besuch hat keine Checkliste.',
    'visita.pendientes': '{total} unmarkiert',
    'visita.completar': 'Besuch abschliessen',
    'visita.abrira': 'oeffnet {total} Vorgaenge',
    'visita.completadaCon': 'Besuch abgeschlossen. {total} Vorgaenge wurden geoeffnet.',
    'visita.completadaSin': 'Besuch ohne Vorgaenge abgeschlossen.',
    'visita.estadoEN_CURSO': 'Laufend',
    'visita.estadoCOMPLETADA': 'Abgeschlossen',
    'visita.estadoABANDONADA': 'Abgebrochen',
    'visita.resOK': 'OK',
    'visita.resINCIDENCIA': 'Vorgang',
    'visita.resNO_APLICA': 'Entfällt',
    'visita.resPENDIENTE': 'Offen',
    'visita.estadoInvalido': 'Der Besuch ist bereits geschlossen.',
    'panel.facturasPorCobrar': 'Offene Rechnungen',
    'panel.emitidaEl': 'Ausgestellt am {fecha}',
    'panel.rendimientoEquipo': 'Teamleistung',
    'panel.cumplimientoNota': 'Abgeschlossene gegen geplante Besuche in diesem Monat.',
    'panel.agendadas': 'Geplant',
    'panel.completadas': 'Abgeschlossen',
    'panel.cumplimiento': 'Erfüllung',
    'panel.sinAgenda': 'kein Plan',
    'panel.informeCartera': 'Monatsbericht',
    'mio.horas': 'Stunden diesen Monat',
    'mio.horasPie': 'in {total} Arbeitsnachweisen',
    'mio.gastos': 'Ausgaben diesen Monat',
    'mio.gastosPie': '{total} erfasst',
    'mio.aCobrar': 'Bisher fällig',
    'mio.aCobrarPie': 'für die erfassten Stunden, zum Satz jeder Immobilie',
    'mio.incidencias': 'Vorgänge in meinen Immobilien',
    'mio.incidenciasPie': '{n1} dringend · {n2} vorrangig',
    'mio.ocupacion': 'Belegte Immobilien',
    'mio.ocupacionPie': 'von denen, die ich betreue',
    'mio.proximasVisitas': 'Nächste Besuche',
    'mio.sinVisitas': 'Keine Besuche geplant.',
    'mio.informe': 'Mein Monatsbericht',
    'mio.informeNota': 'Ihre Stunden, Ihre Besuche, die gelösten Vorgänge und die Vergütungsberechnung.',
    'panel.hola': 'Hallo, {nombre}',
    'panel.margenMes': 'Marge des Monats',
    'panel.margenPie': 'abrechenbar minus Kosten',
    'panel.costeSoportado': 'Getragene Kosten',
    'panel.costePie': 'von der Verwaltung vorgestreckt',
    'panel.facturable': 'An Kunden abrechenbar',
    'panel.facturablePie': 'Kosten plus Marge',
    'panel.gastoInterno': 'Interne Ausgaben',
    'panel.gastoInternoPie': 'Organisation, diesen Monat',
    'panel.clientes': 'Kunden',
    'panel.incidenciasCriticas': 'Kritische Vorgänge',
    'panel.deAbiertas': 'von {total} offen',
    'panel.horasMes': 'Stunden des Monats',
    'panel.horasPie': 'auf Immobilien erfasst',
    'panel.pendienteFacturar': 'Noch nicht abgerechnet',
    'panel.pendienteFacturarNota': 'Freigegebene, weiterberechenbare Arbeit ohne Rechnung.',
    'panel.nGastos': '{total} Ausgaben',
    'panel.esperando': 'wartet {total}T',
    'panel.incidenciasActivas': 'Offene Vorgänge',
    'panel.total': '{total} gesamt',
    'panel.criticasAbiertas': 'Offene kritische Vorgänge',
    'panel.resumenPropiedades': 'Immobilienübersicht',
    'panel.propiedad': 'Immobilie',
    'panel.ocupacion': 'Belegung der Immobilien',
    'panel.ocupadasAhora': 'Jetzt belegt ({total})',
    'panel.ningunaOcupada': 'Derzeit keine belegt.',
    'panel.proximasLlegadas': 'Nächste Anreisen ({total})',
    'panel.noches': '{total} Nächte',
    'panel.proximasVisitas': 'Nächste geplante Besuche',
    'panel.cargaOperativa': 'Auslastung pro Person',
    'panel.horasPorTrabajador': 'Stunden pro Person',
    'panel.actividadReciente': 'Letzte Aktivität',
    'mant.nueva': 'Neue Wartungsaufgabe',
    'mant.titulo': 'Titel',
    'mant.area': 'Bereich',
    'mant.frecuencia': 'Häufigkeit',
    'mant.antelacion': 'Vorlauftage',
    'mant.fechaInicio': 'Startdatum',
    'mant.comoVisita': 'Als Besuch',
    'mant.comoIncidencia': 'Als Vorgang',
    'mant.proveedorOpcional': 'Dienstleister (optional)',
    'mant.guardar': 'Aufgabe speichern',
    'prov.nuevo': 'Neuer Dienstleister',
    'prov.empresa': 'Firma',
    'prov.categoria': 'Kategorie',
    'prov.contacto': 'Kontakt',
    'prov.productos': 'Produkte / Garantien und Notizen',
    'prov.productosPista': 'z. B. Vaillant-Kessel, Garantie bis 2028',
    'gasto.registrar': 'Ausgabe erfassen',
    'gasto.importe': 'Betrag (EUR)',
    'gasto.fecha': 'Datum der Ausgabe',
    'gasto.margen': 'Gewinnmarge (%)',
    'gasto.sinProveedor': 'Kein Dienstleister',
    'gasto.nombreLibre': 'Freier Name',
    'gasto.nombreLibrePista': 'z. B. Leroy Merlin',
    'gasto.conceptoPista': 'z. B. Sanitärmaterial',
    'gasto.facturable': 'Dem Kunden berechenbar',
    'gasto.visiblePortal': 'Im Kundenportal sichtbar',
    'gasto.ticket': 'Foto des Belegs / der Rechnung',
    'gasto.registrarBoton': 'Erfassen',
    'gasto.anadir': 'Hinzufügen',
    'doc.fichero': 'Datei',
    'doc.tipos': 'PDF, Word, Excel oder Bild. Max. 20 MB.',
    'visita.programar': 'Besuch planen',
    'avisos.titulo': 'Benachrichtigungen',
    'avisos.vacio': 'Nichts offen. Alles erledigt.',
    'avisos.marcarTodas': 'Alle als gelesen',
    'avisoTipo.INCIDENCIA_CRITICA': 'Kritischer Vorgang',
    'avisoTipo.VISITA_VENCIDA': 'überfälliger Besuch',
    'avisoTipo.MANTENIMIENTO_VENCIDO': 'überfällige Wartung',
    'avisoTipo.GASTO_PENDIENTE': 'Ausgabe zur Freigabe',
    'avisoTipo.PAGO_RECURRENTE': 'Wiederkehrende Zahlung',
    'avisoTipo.FACTURA_VENCIDA': 'überfällige Rechnung',
    'avisoTipo.OTRO': 'Hinweis',
    'verComo.etiqueta': 'Ansicht als',
    'verComo.aviso': 'Du siehst die App als {rol}.',
    'verComo.volver': 'Zurück zu {rol}',
    'inc.proveedor': 'Dienstleister',
    'inc.sinAsignar': 'Nicht zugewiesen',
    'inc.elegirProveedor': 'Dienstleister wählen...',
    'inc.quitar': 'Entfernen',
    'inc.presupuestos': 'Erhaltene Angebote',
    'inc.solicitar': 'Anfordern',
    'inc.sinPresupuestos': 'Noch keine Angebote.',
    'inc.guardarPresupuesto': 'Angebot speichern',
    'inc.estado': 'Status',
    'inc.pedirMotivo': 'Warum wird er storniert? Das wird im Vorfall festgehalten.',
    'inc.pedirResolucion': 'Wie wurde es gelöst? Das wird im Vorfall festgehalten.',
    'inc.urgencia': 'Dringlichkeit',
    'inc.costeEstimado': 'Geschätzte Kosten',
    'inc.costeFinal': 'Endkosten',
    'inc.fotos': 'Nachweisfotos',
    'inc.anadirFoto': 'Foto hinzufügen',
    'inc.sinFotos': 'Keine Fotos oder Dokumente.',
    'inc.chatInterno': 'Interner Chat',
    'inc.chatInternoNota': 'Noch keine Kommentare. Schreib den ersten.',
    'inc.mensajesCliente': 'Kundennachrichten',
    'inc.mensajesClienteNota': 'Noch keine Nachrichten. Der Kunde kann hier auch schreiben.',
    'inc.visibleAlCliente': 'Für Kunden sichtbar',
    'inc.enviar': 'Senden',
    'inc.fechaEsperada': 'Erwartetes Lösungsdatum',
    'inc.fechaEsperadaNota': 'Das Datum, das sich das Team setzt. Es erscheint am Tag selbst in «Tagesaufgaben», rot sobald es verstreicht. Nicht das SLA.',
    'inc.visibilidad': 'Sichtbarkeit in Portalen',
    'inc.visiblePropietario': 'Für Eigentümer sichtbar',
    'inc.ocultaPropietario': 'Vor Eigentümer verborgen',
    'inc.visibilidadNota': 'Der Eigentümer sieht nur als sichtbar markierte Vorgänge.',
    'inc.creada': 'Erstellt',
    'inc.cerrada': 'Geschlossen',
    'adjunto.tipoNoAdmitido': 'Dieser Dateityp wird nicht akzeptiert.',
    'adjunto.demasiadoGrande': 'Die Datei überschreitet die maximale Größe (20 MB).',
    'adjunto.vacio': 'Die Datei ist leer.',
    'adjunto.rutaInvalida': 'Ungültiger Dateipfad.',
    'ficha.filtroABIERTAS': 'Offen',
    'ficha.filtroCERRADAS': 'Geschlossen',
    'ficha.filtroTODAS': 'Alle',
    'ficha.nivel': 'Stufe',
    'ficha.todos': 'Alle',
    'ficha.sinIncidencias': 'Keine Vorgänge mit diesem Filter.',
    'ficha.slaIncumplido': 'SLA verletzt',
    'ficha.estimado': 'gesch.',
    'ficha.final': 'final',
    'ficha.precioCliente': 'Kundenpreis',
    'ficha.gastado': 'Ausgegeben',
    'ficha.porCobrar': 'Offen',
    'ficha.porCobrarAyuda': 'Was dem Kunden weiterberechnet wird, genehmigt, als „Offen“ markiert und noch nicht in Rechnung gestellt. Gleiche Zahl wie im Dashboard.',
    'ficha.noRepercutido': '{importe} nicht weiterberechnet ({total})',
    'ficha.noRepercutidoAyuda': 'Ausgaben der Immobilie, die nicht als weiterzuberechnen markiert sind. Sie zählen nicht zum offenen Betrag.',
    'ficha.repercutir': 'An Kunden weiterberechnen',
    'ficha.repercutirAyuda': 'Diese Ausgabe wird dem Kunden nicht berechnet. Klicken, um sie auf „Offen“ zu setzen.',
    'ficha.noSeRepercute': 'Nicht weiterberechnet',
    'ficha.confirmarRepercutir': '„{concepto}“ an den Kunden weiterberechnen? Sie wird „Offen“ und im Kundenportal sichtbar.',
    'ficha.alCliente': 'an Kunden',
    'ficha.sinFichero': 'keine Datei',
    'ficha.documentos': 'Verträge und Dokumente',
    'ficha.sinDocumentos': 'Keine Dokumente.',
    'ficha.subirDocumento': 'Dokument hochladen',
    'ficha.tituloDocumento': 'Titel des Dokuments',
    'ficha.urlDocumento': 'Dateiadresse',
    'ficha.abrir': 'öffnen',
    // --- KI und Auswertung ----------------------------------------------------
    'ia.anio': 'Jahr',
    'ia.mes': 'Monat',
    'ia.resumenesTitulo': 'Zusammenfassungen für das Eigentümerportal',
    'ia.resumenesIntro': 'Über einen abgeschlossenen Monat erstellt, geprüft und veröffentlicht. Der Eigentümer liest, was das Unternehmen entschieden hat — nicht, was ein Modell beim Laden der Seite improvisiert.',
    'ia.eligePropiedad': 'Immobilie wählen',
    'ia.idiomaResumen': 'Sprache der Zusammenfassung',
    'ia.generar': 'Erstellen',
    'ia.generando': 'Wird erstellt…',
    'ia.sinResumenes': 'Für diesen Monat gibt es noch keine Zusammenfassung.',
    'ia.estado.BORRADOR': 'Entwurf',
    'ia.estado.PUBLICADO': 'Veröffentlicht',
    'ia.editar': 'Bearbeiten',
    'ia.guardar': 'Speichern',
    'ia.publicar': 'Für den Kunden veröffentlichen',
    'ia.retirar': 'Zurückziehen',
    'ia.escritoAMano': 'von Hand korrigiert',
    'ia.conectada': 'Verbunden',
    'ia.sinProveedor': 'Kein Anbieter',
    'ia.sinProveedorNota': 'Es ist kein KI-Anbieter konfiguriert, daher lässt sich keine Zusammenfassung erstellen. Ohne KI gibt es keine als solche getarnte Vorlage.',
    'ia.informesTitulo': 'Tätigkeitsberichte',
    'ia.informesIntro': 'Für den gewählten Monat, als PDF. Der Bericht jeder Person enthält Stunden, Besuche, gelöste Vorgänge und die Vergütungsberechnung.',
    'ia.informeCartera': 'Gesamtes Portfolio',
    'ia.informeCarteraNota': 'Alle Immobilien des Monats',
    'ia.descargar': 'Herunterladen',
    'ia.conexionTitulo': 'KI-Verbindung',
    'ia.pruebaOk': 'Die Verbindung funktioniert.',
    'ia.pruebaFallo': 'Die Verbindung ist fehlgeschlagen.',
    'ia.noConfigurada': 'Die KI ist nicht konfiguriert: Die Zusammenfassung kann nicht erstellt werden.',
    'mes.enero': 'Januar',
    'mes.febrero': 'Februar',
    'mes.marzo': 'März',
    'mes.abril': 'April',
    'mes.mayo': 'Mai',
    'mes.junio': 'Juni',
    'mes.julio': 'Juli',
    'mes.agosto': 'August',
    'mes.septiembre': 'September',
    'mes.octubre': 'Oktober',
    'mes.noviembre': 'November',
    'mes.diciembre': 'Dezember',
    'ia.titulo': 'KI und Berichte',
    'ia.sub': 'Die Monatszusammenfassung für den Eigentümer und die Tätigkeitsberichte.',
    'ia.conexion': 'KI-Verbindung',
    'ia.probar': 'Verbindung testen',
    'ia.probando': 'Wird getestet…',
    'ia.conexionPie': 'Sendet eine echte, minimale Anfrage an den Anbieter. Das kostet ein paar Cent, deshalb geschieht es nicht von selbst beim Öffnen dieser Seite. Es ist die Verbindung, die die Zusammenfassung im Kundenportal nutzt — heute die einzige Stelle, an der die KI etwas schreibt.',
    'ia.noSeProbo': 'Die Verbindung konnte nicht getestet werden.',
    'ia.anomalias': 'Auffällige Ausgaben (letzte {meses} Monate)',
    'ia.analizando': 'Wird ausgewertet…',
    'ia.sinAnomalias': 'Keine Auffälligkeiten gefunden. Geprüft wird gegen die eigene Historie.',
    'ia.noSeCargaron': 'Die Auffälligkeiten konnten nicht geladen werden.',
    'ia.severidad': 'Schweregrad',
    'ia.tipo': 'Art',
    'ia.concepto': 'Position',
    'ia.propiedad': 'Immobilie',
    'ia.importe': 'Betrag',
    'ia.motivo': 'Grund',
    'ia.tipoOUTLIER': 'Ungewöhnlicher Betrag',
    'ia.tipoDUPLICADO': 'Möglicherweise doppelt',
    'ia.sevALTA': 'Hoch',
    'ia.sevMEDIA': 'Mittel',
    'ia.sevBAJA': 'Niedrig',
    'ia.clasificar': 'Einen Vorfall einstufen',
    'ia.clasificarPie': 'Beschreibe den Vorfall, und es wird eine Stufe und eine Kategorie vorgeschlagen (es entscheidet nicht, es weist nur hin). Der Vorschlag stammt aus einer Stichwort-Heuristik, nicht aus der KI.',
    'ia.clasificarEjemplo': 'Z. B.: Unter der Küchenspüle tritt Wasser aus',
    'ia.clasificarBoton': 'Einstufen',
    'ia.noSeClasifico': 'Es konnte nicht eingestuft werden.',
    'ia.nivelSugerido': 'Stufe {nivel}',
    'ia.porIa': 'von der KI',
    'ia.porHeuristica': 'Heuristik',
    'iaCat.SEGURIDAD': 'Sicherheit',
    'iaCat.FONTANERIA': 'Sanitär',
    'iaCat.ELECTRICIDAD': 'Elektrik',
    'iaCat.CLIMATIZACION': 'Heizung und Klima',
    'iaCat.CERRAJERIA': 'Schlösser und Verglasung',
    'iaCat.EXTERIORES': 'Außenanlagen',
    'iaCat.MANTENIMIENTO': 'Instandhaltung',
    'iaCat.GENERAL': 'Allgemein',
    'dia.titulo': 'Aufgaben für heute',
    'dia.nadaPendiente': 'Nichts offen',
    'dia.pendientes': '{total} offen',
    'dia.vacio': 'Für heute stehen keine Aufgaben mit Termin und keine Besuche an. Aufgaben ohne Fälligkeitsdatum erscheinen hier nicht.',
    'dia.incidencias': 'Offene Vorgänge',
    'dia.visitas': 'Geplante Besuche',
    'dia.deProyectos': 'Aus Projekten',
    'dia.sinPropiedad': 'Ohne Objekt',
    'dia.ver': 'Ansehen',
    'dia.hoy': 'Heute',
    'dia.atrasada': 'Überfällig',
    'dia.completarTarea': '{titulo} abschließen',
    'dia.noSeCargo': 'Der Tag konnte nicht geladen werden.',
    'dia.noSeCompleto': 'Die Aufgabe konnte nicht abgeschlossen werden.',
    'fin.tarifasGenerales': 'Allgemeine Teamsätze',
    'fin.tarifasGeneralesPie': 'Was jede Person verdient, wenn ein Objekt keinen eigenen Satz hat, und womit interne Stunden bezahlt werden. Auf einen Betrag klicken, um ihn zu ändern.',
    'fin.titulo': 'Finanzen',
    'fin.sub': 'Monatsübersicht: Stunden und Kosten, umgerechnet in das, was abgerechnet wird.',
    'fin.registrar': '+ Stunden/Kosten erfassen',
    'fin.ocultarRegistro': 'Formular ausblenden',
    'fin.mes': 'Monat',
    'fin.anio': 'Jahr',
    'fin.noSeCargo': 'Die Übersicht konnte nicht geladen werden.',
    'fin.base': 'Netto',
    'fin.iva': 'MwSt.',
    'fin.total': 'Gesamt',
    'fin.vacio': 'Für {mes} {anio} sind keine Stunden und keine Kosten erfasst.',
    'fin.colTipo': 'Art',
    'fin.colConcepto': 'Position',
    'fin.colPropiedad': 'Objekt',
    'fin.colPersona': 'Person',
    'fin.colBase': 'Netto',
    'fin.colTotal': 'Gesamt',
    'fin.colFacturacion': 'Abrechnung',
    'fin.tipoHORAS_FIJAS': 'Pauschale',
    'fin.tipoHORAS': 'Stunden',
    'fin.tipoGASTO': 'Kosten',
    'fin.modoFACTURA_CON_IVA': 'Rechnung mit MwSt.',
    'fin.modoPRESUPUESTO_SIN_IVA': 'Angebot',
    'fin.modoHOLDED': 'Holded',
    'ref.titulo': 'Empfehlungen',
    'ref.sub': 'Wer dir Geschäft bringt und was er dafür bekommt.',
    'ref.nuevo': 'Neue Empfehlung',
    'ref.nombrePlaceholder': 'Name der Empfehlung',
    'ref.comision': 'Provision',
    'ref.porcentaje': 'Prozentual',
    'ref.fija': 'Fest',
    'ref.porcentajeCampo': 'Prozentsatz (%)',
    'ref.importeCampo': 'Betrag (€)',
    'ref.anadir': '+ Hinzufügen',
    'ref.filtroTODOS': 'Alle',
    'ref.filtroPENDIENTE': 'Offen',
    'ref.filtroCONVERTIDO': 'Umgewandelt',
    'ref.filtroDESCARTADO': 'Verworfen',
    'ref.vacio': 'Keine Empfehlungen in diesem Status.',
    'ref.colReferido': 'Empfehlung',
    'ref.colQuienRefiere': 'Empfohlen von',
    'ref.colEstado': 'Status',
    'ref.colAcciones': 'Aktionen',
    'ref.estadoPENDIENTE': 'Offen',
    'ref.estadoCONVERTIDO': 'Umgewandelt',
    'ref.estadoDESCARTADO': 'Verworfen',
    'ref.basePlaceholder': 'Basis €',
    'ref.baseDe': 'Basis für {nombre}',
    'ref.convertir': 'Umwandeln',
    'ref.descartar': 'Verwerfen',
    'ref.motivoDescarte': 'Aus der Übersicht verworfen',
    'ref.noSeCargaron': 'Die Empfehlungen konnten nicht geladen werden.',
    'ref.noSeCreo': 'Die Empfehlung konnte nicht angelegt werden.',
    'ref.noSeConvirtio': 'Sie konnte nicht umgewandelt werden.',
    'ref.noSeDescarto': 'Sie konnte nicht verworfen werden.',
    'import.crmTitulo': 'Verkaufschancen aus dem vorherigen CRM',
    'import.crmIntro': 'Holt die Vertriebspipeline aus dem vorherigen CRM. Wiederholbar: Jede Verkaufschance trägt die Kennung aus ihrer Quelle, ein zweiter Lauf aktualisiert statt zu duplizieren.',
    'import.crmOportunidades': 'Verkaufschancen',
    'import.crmCreadas': 'Angelegt',
    'import.crmActualizadas': 'Aktualisiert',
    'import.crmTotal': 'Gesamt',
    'import.crmSuma': 'Gesamtwert',
    'import.crmNotas': 'Neue Notizen',
    'import.crmTareas': 'Neue Aufgaben',
    'import.crmFusionadas': 'Am Namen erkannt ({n}):',
    'import.crmPorEmbudo': 'Nach Pipeline',
    'import.crmEmbudosCreados': 'Angelegte Pipelines',
    'import.crmEtapasCreadas': 'Angelegte Phasen',
    'import.crmResponsables': 'Zugeordnete Verantwortliche',
    'import.embudoDesconocido': 'Diese Pipeline gibt es in der Anwendung nicht. Vor dem Import anlegen.',
    'import.etapaDesconocida': 'Eine Phase aus der Datei gibt es in ihrer Pipeline nicht. Es wurde nichts importiert.',
    'import.exclusivoDesconocido': 'Eine Verkaufschance in der Datei ist exklusiv einer Person zugeordnet, die kein Benutzer des Unternehmens ist. Es wurde nichts importiert.',
    'import.externalIdRepetido': 'Die Datei enthält dieselbe Verkaufschance zweimal.',
    'import.totalNoCuadra': 'Die Anzahl stimmt nicht mit der erwarteten überein. Es wurde nichts importiert.',
    'import.sumaNoCuadra': 'Der Gesamtwert stimmt nicht mit dem erwarteten überein. Es wurde nichts importiert.',
    'crm.embudo': 'Pipeline',
    'crm.origen': 'Quelle',
    'crm.etiquetas': 'Schlagworte',
    'crm.contacto': 'Kontakt',
    'crm.responsableOriginal': 'Verantwortlich im vorherigen CRM',
    'crm.datosExternos': 'Übernommene Qualifizierung',
    'crm.importada': 'Importiert',
    'crm.sub': 'Steuere deinen Vertrieb über Pipelines.',
    'crm.nuevaOportunidad': 'Neue Gelegenheit',
    'crm.nombrePlaceholder': 'Name (z. B. Villa an der Klippe)',
    'crm.valor': 'Wert (€, optional)',
    'crm.anadir': '+ Hinzufügen',
    'crm.ganada': 'Gewonnen',
    'crm.perdida': 'Verloren',
    'crm.mover': '{nombre} verschieben',
    'crm.noSeCargaronEmbudos': 'Die Pipelines konnten nicht geladen werden.',
    'crm.noSeCargaronOportunidades': 'Die Gelegenheiten konnten nicht geladen werden.',
    'crm.faltaNombre': 'Geben Sie einen Namen für die Verkaufschance ein.',
    'crm.noSeCreo': 'Die Gelegenheit konnte nicht angelegt werden.',
    'crm.noSeMovio': 'Die Gelegenheit konnte nicht verschoben werden.',
    'crm.ficha.info': 'Kontakt und Verkaufschance',
    'crm.ficha.propiedad': 'Details der Immobilie',
    'crm.ficha.tareas': 'Aufgaben',
    'crm.ficha.notas': 'Notizen',
    'crm.ficha.contacto': 'Kontaktdaten',
    'crm.ficha.oportunidad': 'Details der Verkaufschance',
    'crm.ficha.ocultarVacios': 'Leere Felder ausblenden',
    'crm.ficha.contactoNombre': 'Name des Hauptkontakts',
    'crm.ficha.email': 'E-Mail',
    'crm.ficha.telefono': 'Telefon',
    'crm.ficha.llamar': 'Anrufen',
    'crm.ficha.adicionales': 'Weitere Kontakte (max. 10)',
    'crm.ficha.anadirContacto': 'Kontakt hinzufügen',
    'crm.ficha.rol': 'Funktion',
    'crm.ficha.nombre': 'Name der Verkaufschance',
    'crm.ficha.embudo': 'Pipeline',
    'crm.ficha.etapa': 'Phase',
    'crm.ficha.estado': 'Status',
    'crm.estado.ABIERTA': 'Offen',
    'crm.estado.GANADA': 'Gewonnen',
    'crm.estado.PERDIDA': 'Verloren',
    'crm.ficha.valor': 'Wert (€)',
    'crm.ficha.motivoPerdida': 'Grund für den Verlust',
    'crm.ficha.propietario': 'Verantwortlich',
    'crm.ficha.sinAsignar': 'Nicht zugewiesen',
    'crm.ficha.seguidores': 'Beobachter',
    'crm.ficha.anadirSeguidor': 'Beobachter hinzufügen',
    'crm.ficha.quitar': 'Entfernen',
    'crm.ficha.empresa': 'Firmenname',
    'crm.ficha.fuente': 'Quelle',
    'crm.ficha.cierrePrevisto': 'Voraussichtlicher Abschluss',
    'crm.ficha.etiquetas': 'Schlagwörter',
    'crm.ficha.anadirEtiqueta': 'Schlagwort hinzufügen',
    'crm.ficha.encaje': 'Kulturelle Passung',
    'crm.ficha.idioma': 'Sprache',
    'crm.ficha.usoReal': 'Tatsächliche Nutzung',
    'crm.ficha.riesgos': 'Erkannte Risiken',
    'crm.ficha.zona': 'Gegend',
    'crm.ficha.superficie': 'Ungefähre Fläche',
    'crm.ficha.tipoPropiedad': 'Art der Immobilie',
    'crm.ficha.vistas': 'Aussicht',
    'crm.ficha.m2Solar': 'Min. Grundstück m²',
    'crm.ficha.m2Habitables': 'Min. Wohnfläche m²',
    'crm.ficha.dormitorios': 'Schlafzimmer',
    'crm.ficha.banos': 'Badezimmer',
    'crm.ficha.propuestoMax': 'Max. Angebot €',
    'crm.ficha.estaEnLaIsla': 'Auf der Insel',
    'crm.ficha.viveEnLaIsla': 'Wohnt auf der Insel',
    'crm.ficha.creadoPor': 'Erstellt von: {nombre}',
    'crm.ficha.creadoEl': 'Erstellt am {fecha}',
    'crm.ficha.guardado': 'Gespeichert.',
    'crm.ficha.descartarCambios': 'Es gibt ungespeicherte Änderungen. Trotzdem schließen?',
    'crm.ficha.anadirTarea': 'Aufgabe hinzufügen',
    'crm.ficha.tituloTarea': 'Was zu tun ist',
    'crm.ficha.vence': 'Fällig am',
    'crm.ficha.responsableTarea': 'Wer sie erledigt',
    'crm.ficha.detalleTarea': 'Details (optional)',
    'crm.ficha.tareaEnPanel': 'Sie erscheint im Tagesplan der Person, die sie erledigt.',
    'crm.ficha.buscarTarea': 'Nach Titel suchen',
    'crm.ficha.sinTareas': 'Noch keine Aufgaben.',
    'crm.ficha.sinFechaNiResponsable': 'Ohne Datum und Verantwortliche',
    'crm.ficha.buscarNotas': 'Notizen suchen',
    'dia.crm': 'Aus Verkaufschancen',
    'crm.exclusiva': 'Exklusiv bei {nombre}',
    'crm.error.exclusivoSinCrm': 'Diese Person hat keinen Zugriff auf das CRM und kann daher keine Verkaufschance exklusiv betreuen.',
    'crm.asistente.titulo': 'Assistent',
    'crm.asistente.abrir': 'Assistent',
    'crm.asistente.intro': 'Erzähl mir, was mit einem Kunden passiert ist – so wie du es einem Kollegen erzählen würdest – oder füge einen Screenshot des Gesprächs ein. Ich kann auch einen neuen Kunden anlegen. Ich schlage die Änderungen vor – Notiz, Spalte, nächster Schritt – und du entscheidest, was übernommen wird.',
    'crm.asistente.placeholder': 'Z. B.: Mit Pouline gesprochen, sie prüft unser Angebot',
    'crm.asistente.enviar': 'Senden',
    'crm.asistente.adjuntar': 'Screenshot anhängen',
    'crm.asistente.dictar': 'Diktieren',
    'crm.asistente.pararDictado': 'Diktat beenden',
    'crm.asistente.escuchando': 'Ich höre zu… sprich ganz normal und tippe zum Beenden auf das Mikrofon. Vor dem Senden prüfen.',
    'crm.asistente.dictado.noSoportado': 'Dieser Browser kann nicht diktieren. Am Handy das Mikrofon der Tastatur verwenden.',
    'crm.asistente.dictado.permiso': 'Zum Diktieren den Mikrofonzugriff im Browser erlauben.',
    'crm.asistente.dictado.sinVoz': 'Ich habe nichts gehört. Tippe auf das Mikrofon und versuche es erneut.',
    'crm.asistente.dictado.red': 'Keine Verbindung zum Diktierdienst. Bitte erneut versuchen.',
    'crm.asistente.dictado.otro': 'Diktieren hat nicht geklappt. Bitte erneut versuchen.',
    'crm.asistente.quitarCaptura': 'Screenshot entfernen',
    'crm.asistente.demasiadas': 'Höchstens 6 Screenshots pro Nachricht.',
    'crm.asistente.pensando': 'Lese… {segundos} s',
    'crm.asistente.pensandoPie': 'Mit Screenshots kann es bis zu einer Minute dauern.',
    'crm.asistente.aplicar': 'Übernehmen',
    'crm.asistente.aplicarN': 'Übernehmen ({n})',
    'crm.asistente.descartar': 'Verwerfen',
    'crm.asistente.aplicada': 'Übernommen',
    'crm.asistente.aplicadoUna': 'Erledigt: Verkaufschance aktualisiert.',
    'crm.asistente.aplicadoVarias': 'Erledigt: {n} Verkaufschancen aktualisiert.',
    'crm.asistente.creadaUna': 'Erledigt: Verkaufschance angelegt.',
    'crm.asistente.creadasVarias': 'Erledigt: {n} Verkaufschancen angelegt.',
    'crm.asistente.aplicadoMixto': 'Erledigt: {actualizadas} aktualisiert und {creadas} neu.',
    'crm.asistente.descartado': 'Verworfen. Es wurde nichts geändert.',
    'crm.asistente.nota': 'Notiz',
    'crm.asistente.nueva': 'Neue Verkaufschance',
    'crm.asistente.mover': 'Von «{desde}» nach «{hasta}» verschieben',
    'crm.asistente.tarea': 'Aufgabe: {titulo}',
    'crm.asistente.tareaVence': 'Aufgabe: {titulo} · {fecha}',
    'crm.asistente.confianzaALTA': 'Sicher',
    'crm.asistente.confianzaMEDIA': 'Wahrscheinlich',
    'crm.asistente.confianzaBAJA': 'Unsicher',
    'crm.asistente.ganada': 'Schließt sie als gewonnen',
    'crm.asistente.perdida': 'Schließt sie als verloren',
    'crm.asistente.descartadas': 'Nicht vorgeschlagen:',
    'crm.asistente.transcripcion': 'Was ich in den Screenshots gelesen habe',
    'crm.asistente.nuevo': 'Neues Gespräch',
    'crm.asistente.error': 'Ich konnte es nicht auswerten. Bitte erneut versuchen.',
    'crm.asistente.sinIa': 'Der Assistent ist nicht eingerichtet: Der KI-Schlüssel fehlt.',
    'crm.detalle.abrir': '{nombre} öffnen',
    'crm.detalle.exclusiva': 'Exklusive Betreuung',
    'crm.detalle.nadie': 'Niemand: jeder darf Kontakt aufnehmen',
    'crm.detalle.nuevaNota': 'Notiz hinzufügen',
    'crm.detalle.guardarNota': 'Notiz speichern',
    'crm.detalle.sinHistorial': 'Noch keine Notizen.',
    'crm.actividad.NOTA': 'Notiz',
    'crm.actividad.LLAMADA': 'Anruf',
    'crm.actividad.REUNION': 'Termin',
    'crm.actividad.EMAIL': 'E-Mail',
    'crm.actividad.TAREA': 'Aufgabe',
    'finreg.titulo': 'Stunden und Kosten erfassen',
    'finreg.horas': 'Stunden',
    'finreg.gasto': 'Kosten',
    'finreg.persona': 'Person',
    'finreg.yo': 'Ich ({nombre})',
    'finreg.propiedad': 'Objekt',
    'finreg.general': '— Allgemein —',
    'finreg.fecha': 'Datum',
    'finreg.tipo': 'Art',
    'finreg.tipoGESTION': 'Verwaltung',
    'finreg.tipoOTRO': 'Sonstiges',
    'finreg.registrarHoras': 'Stunden erfassen',
    'finreg.concepto': 'Position',
    'finreg.conceptoPlaceholder': 'Material, Transport…',
    'finreg.categoria': 'Kategorie',
    'finreg.catLOGISTICA': 'Logistik',
    'finreg.catCOMPRA': 'Einkauf',
    'finreg.catOTRO': 'Sonstiges',
    'finreg.coste': 'Kosten (€)',
    'finreg.margen': 'Marge (%)',
    'finreg.registrarGasto': 'Kosten erfassen',
    'finreg.tarifas': 'Sätze des Teams',
    'finreg.tarifasPie': 'Ohne Satz werden erfasste Stunden mit 0 € gerechnet. Lege fest, was jede Person berechnet: fest pro Monat und Objekt, oder pro Stunde.',
    'finreg.tarifasSinPropiedad': 'Der Satz ohne Objekt gilt für interne Stunden und ebenso für jedes Haus, das keinen eigenen Satz hat.',
    'finreg.horasInternas': 'Interne Stunden · ohne Objekt',
    'finreg.horasInternasOpcion': '— Interne Stunden · ohne Objekt —',
    'finreg.modalidad': 'Berechnung',
    'finreg.porHora': 'Pro Stunde',
    'finreg.fijaMes': 'Fest pro Monat',
    'finreg.fijaMesCorto': 'Fest/Monat',
    'finreg.importe': 'Betrag (€)',
    'finreg.fijarTarifa': 'Satz festlegen',
    'finreg.tarifaFijada': 'Satz festgelegt.',
    'finreg.horasRegistradas': 'Stunden erfasst.',
    'finreg.facturaNoSubio': 'Die Ausgabe wurde erfasst, die Rechnung konnte aber nicht hochgeladen werden.',
    'finreg.gastoRegistrado': 'Kosten erfasst.',
    'finreg.indicaImporte': 'Gib den Betrag des Satzes an.',
    'finreg.indicaHoras': 'Gib an, wie viele Stunden.',
    'finreg.indicaGasto': 'Gib Position und Betrag an.',
    'finreg.noSeFijo': 'Der Satz konnte nicht festgelegt werden.',
    'finreg.noSeRegistraronHoras': 'Die Stunden konnten nicht erfasst werden.',
    'finreg.noSeRegistroGasto': 'Die Kosten konnten nicht erfasst werden.',
    'app.modulos': 'Module',
    'app.navegacion': 'Navigation',
    'proy.titulo': 'Projekte',
    'proy.sub': 'Teams, Projekte und Aufgaben.',
    'proy.estadoTODO': 'Zu tun',
    'proy.estadoEN_CURSO': 'In Arbeit',
    'proy.estadoBLOQUEADA': 'Blockiert',
    'proy.estadoHECHA': 'Erledigt',
    'proy.hoy': 'Heute',
    'proy.ayer': 'Gestern',
    'proy.manana': 'Morgen',
    'proy.sinSeccion': 'Ohne Abschnitt',
    'proy.subtareas': 'Teilaufgaben',
    'proy.comentarios': 'Kommentare',
    'proy.adjuntos': 'Anhänge',
    'proy.reabrir': '{titulo} wieder öffnen',
    'proy.completar': '{titulo} abschließen',
    'proy.unaTarea': '{total} Aufgabe',
    'proy.variasTareas': '{total} Aufgaben',
    'proy.vista': 'Ansicht',
    'proy.lista': 'Liste',
    'proy.tablero': 'Board',
    'proy.buscarTarea': 'Aufgabe suchen',
    'proy.verCompletadas': 'Erledigte anzeigen',
    'proy.colNombre': 'Name der Aufgabe',
    'proy.colResponsable': 'Zuständig',
    'proy.colFecha': 'Fällig am',
    'proy.colColaboradores': 'Mitwirkende',
    'proy.anadirTarea': '+ Aufgabe hinzufügen',
    'proy.anadirTareaEn': 'Aufgabe in {seccion} hinzufügen',
    'proy.estadoDe': 'Status von {titulo}',
    'proy.nuevaSeccion': 'Neuer Abschnitt',
    'proy.anadirSeccion': '+ Abschnitt hinzufügen',
    'proy.sinEquipos': 'Noch keine Teams. Lege unten das erste an.',
    'proy.sinProyectos': 'Noch keine Projekte.',
    'proy.nuevoProyecto': 'Neues Projekt',
    'proy.nuevoProyectoEn': 'Neues Projekt in {equipo}',
    'proy.nuevoEquipo': 'Neues Team',
    'proy.nombreEquipo': 'Name des Teams',
    'proy.anadir': '+ Hinzufügen',
    'proy.noSeCargaron': 'Die Projekte konnten nicht geladen werden.',
    'proy.noSeAbrio': 'Das Projekt konnte nicht geöffnet werden.',
    'proy.noSeCreoTarea': 'Die Aufgabe konnte nicht angelegt werden.',
    'proy.noSeCambio': 'Die Aufgabe konnte nicht geändert werden.',
    'proy.noSeMovio': 'Die Aufgabe konnte nicht verschoben werden.',
    'proy.noSeCreoSeccion': 'Der Abschnitt konnte nicht angelegt werden.',
    'proy.noSeCreoProyecto': 'Das Projekt konnte nicht angelegt werden.',
    'proy.noSeCreoEquipo': 'Das Team konnte nicht angelegt werden.',
    'tarea.completada': '✓ Erledigt',
    'tarea.marcarCompletada': 'Als erledigt markieren',
    'tarea.cerrar': 'Schließen',
    'tarea.titulo': 'Titel der Aufgabe',
    'tarea.responsables': 'Zuständige',
    'tarea.quitarA': '{nombre} entfernen',
    'tarea.asignar': '+ Zuweisen',
    'tarea.fecha': 'Fällig am',
    'tarea.prioridad': 'Priorität',
    'tarea.prioALTA': 'Hoch',
    'tarea.prioMEDIA': 'Mittel',
    'tarea.prioBAJA': 'Niedrig',
    'tarea.etiquetas': 'Schlagwörter',
    'tarea.nuevaEtiqueta': '+ Schlagwort',
    'tarea.anadirEtiqueta': 'Schlagwort hinzufügen',
    'tarea.descripcion': 'Beschreibung',
    'tarea.subtareas': 'Teilaufgaben',
    'tarea.anadirSubtarea': '+ Teilaufgabe hinzufügen',
    'tarea.reabrir': '{titulo} wieder öffnen',
    'tarea.completar': '{titulo} abschließen',
    'tarea.comentarios': 'Kommentare',
    'tarea.sinComentarios': 'Noch keine.',
    'tarea.alguien': 'Jemand',
    'tarea.escribeComentario': 'Schreibe einen Kommentar',
    'tarea.noSeAbrio': 'Die Aufgabe konnte nicht geöffnet werden.',
    'tarea.noSeGuardo': 'Die Änderung konnte nicht gespeichert werden.',
    'tarea.noSeCambioSubtarea': 'Die Teilaufgabe konnte nicht geändert werden.',
    'tarea.noSeQuitoEtiqueta': 'Das Schlagwort konnte nicht entfernt werden.',
    'tarea.noSePusoEtiqueta': 'Das Schlagwort konnte nicht gesetzt werden.',
    'tarea.noSeCreoSubtarea': 'Die Teilaufgabe konnte nicht angelegt werden.',
    'tarea.noSePublico': 'Der Kommentar konnte nicht veröffentlicht werden.',
    'ia.menu': 'KI',
    'obras.entrada': 'Bauvorhaben',
    'obras.embudos': 'Vertriebs-Pipelines',
    'obras.titulo': 'Bauvorhaben',
    'obras.sub': 'Laufende Bauvorhaben auf Mallorca kurz vor der Übergabe, und mit wem zu sprechen ist.',
    'obras.simulacion': 'Die Rollenrechte werden unten noch simuliert; die Chancen werden aber wirklich gespeichert.',
    'obras.cActivas': 'Aktiv',
    'obras.cPendientes': 'Nicht kontaktiert',
    'obras.cContacto': 'Im Kontakt',
    'obras.cFin': 'Übergabe bald',
    'obras.cVencidas': 'Überfällige Aktionen',
    'obras.cAlta': 'Hohe Priorität',
    'obras.buscar': 'Suche nach Name, Adresse, Gebiet, Code oder Kontakt',
    'obras.nueva': '+ Neues Vorhaben',
    'obras.mapa': 'Karte',
    'obras.lista': 'Liste',
    'obras.mapaCalle': 'Straßenkarte',
    'obras.mapaSatelite': 'Satellit',
    'obras.mapaPie': 'Zoomen mit + / − oder Strg und Mausrad. Auf eine Nadel klicken für die Kurzkarte; erneut klicken, um das Bauvorhaben zu öffnen.',
    'obras.verMapa': 'Auf der Karte zeigen',
    'obras.verLista': 'Als Liste zeigen',
    'obras.filtros': 'Filter',
    'obras.limpiar': 'Filter zurücksetzen',
    'obras.atajos': 'Schnellzugriff',
    'obras.soloVencidas': 'Nur überfällige Aktionen',
    'obras.soloAlta': 'Nur hohe Priorität',
    'obras.soloFin': 'Übergabe in 90 Tagen',
    'obras.soloPendientes': 'Noch nicht kontaktiert',
    'obras.soloActivas': 'Geschlossene ausblenden',
    'obras.resultados': '{total} von {sobre}',
    'obras.zoom': 'Kartenzoom',
    'obras.acercar': 'Vergrößern',
    'obras.alejar': 'Verkleinern',
    'obras.encuadrar': 'An die Vorhaben anpassen',
    'obras.mapaVacio': 'Kein Vorhaben entspricht den Filtern.',
    'obras.mapaNota': 'Eigene Karte, ohne externen Anbieter. Die Küstenlinie ist echt, die Viertel sind ungefähr, die Adressen erfunden.',
    'obras.leyenda': 'Wie man eine Markierung liest',
    'obras.leyendaAnillo': 'Ring und Zahl: Baufortschritt',
    'obras.leyendaDistintivo': 'Das Abzeichen: Stand des Gesprächs',
    'obras.abrir': 'Vorhaben öffnen',
    'obras.cerrarFicha': 'Karte schließen',
    'obras.progreso': 'Fortschritt',
    'obras.fase': 'Bauphase',
    'obras.finEstimada': 'Voraussichtliche Fertigstellung',
    'obras.puntuacion': 'Bewertung',
    'obras.responsable': 'Zuständig',
    'obras.sinResponsable': 'Nicht zugewiesen',
    'obras.ultimaComprobacion': 'Zuletzt geprüft',
    'obras.promotorPropietario': 'Bauträger oder Eigentümer',
    'obras.valorMercado': 'Marktwert',
    'obras.potencial': 'Potenzial für SOLUXE',
    'obras.etapaComercial': 'Vertriebsstatus',
    'obras.zona': 'Gebiet',
    'obras.municipio': 'Gemeinde',
    'obras.direccion': 'Adresse',
    'obras.codigoPostal': 'Postleitzahl',
    'obras.codigo': 'Code',
    'obras.tipoProyecto': 'Art des Projekts',
    'obras.confianza': 'Verlässlichkeit der Schätzung',
    'obras.sinDato': 'Keine Angabe',
    'obras.desconocido': 'Noch nicht bekannt',
    'obras.proximaAccion': 'Nächste Aktion',
    'obras.sinProxima': 'Keine nächste Aktion',
    'obras.sinProximaAviso': 'Dieses Vorhaben ist aktiv und hat nichts geplant.',
    'obras.marcarHecha': 'Als erledigt markieren',
    'obras.nuevaAccion': 'Neue Aktion',
    'obras.quienLaHace': 'Wer macht es',
    'obras.cuando': 'Wann',
    'obras.prioridadCampo': 'Priorität',
    'obras.recordatorio': 'Erinnere mich',
    'obras.recordatorioNota': 'Die Erinnerung ist intern und simuliert: Es wird nichts versendet.',
    'obras.anadirAccion': 'Aktion hinzufügen',
    'obras.descripcion': 'Beschreibung',
    'obras.porQue': 'Warum diese Bewertung',
    'obras.comoSeCalcula': 'Eine Summe aus sieben festen Regeln. Keine KI beteiligt, und das Ergebnis ändert sich nicht.',
    'obras.pt.cerrada': 'Abgeschlossen: konkurriert nicht um Aufmerksamkeit',
    'obras.pt.finEn': 'Fertigstellung in {dias} Tagen erwartet',
    'obras.pt.finPasada': 'Der geplante Termin liegt {dias} Tage zurück',
    'obras.pt.sinFecha': 'Kein Fertigstellungstermin',
    'obras.pt.valor': 'Marktwert',
    'obras.pt.sinValor': 'Marktwert unbekannt',
    'obras.pt.decisor': 'Eine entscheidende Person ist bekannt',
    'obras.pt.propietarioConocido': 'Eigentümer bekannt, Entscheider nicht bestätigt',
    'obras.pt.sinDecisor': 'Weder Eigentümer noch Entscheider bekannt',
    'obras.pt.contacto': 'Direkte Telefonnummer oder E-Mail vorhanden',
    'obras.pt.sinContacto': 'Keine nutzbaren Kontaktdaten',
    'obras.pt.avance': 'Das Gespräch ist bereits fortgeschritten',
    'obras.pt.potencial': 'Geschätztes Potenzial für SOLUXE',
    'obras.pt.sinVerificar': 'Nie vor Ort geprüft',
    'obras.pt.vieja': 'Seit {dias} Tagen nicht überprüft',
    'obras.prioridad.ALTA': 'Hohe Priorität',
    'obras.prioridad.MEDIA': 'Mittlere Priorität',
    'obras.prioridad.BAJA': 'Niedrige Priorität',
    'obras.frescura.RECIENTE': 'Aktuell',
    'obras.frescura.VERIFICAR': 'Sollte geprüft werden',
    'obras.frescura.DESACTUALIZADA': 'Veraltet',
    'obras.frescura.SIN_VERIFICAR': 'Nicht geprüft',
    'obras.comprobar': 'Prüfung erfassen',
    'obras.comprobarNota': 'Was gesehen wurde',
    'obras.estadoAccion.VENCIDA': 'Überfällig',
    'obras.estadoAccion.HOY': 'Heute fällig',
    'obras.estadoAccion.PROXIMA': 'Bevorstehend',
    'obras.estadoAccion.SIN_ACCION': 'Keine Aktion',
    'obras.fase.PREPARACION_TERRENO': 'Baufeldvorbereitung',
    'obras.fase.CIMENTACION': 'Fundament',
    'obras.fase.ESTRUCTURA': 'Rohbau',
    'obras.fase.CERRAMIENTOS': 'Gebäudehülle',
    'obras.fase.INSTALACIONES': 'Haustechnik',
    'obras.fase.ACABADOS_INTERIORES': 'Innenausbau',
    'obras.fase.EXTERIORES': 'Außenanlagen',
    'obras.fase.PREPARACION_ENTREGA': 'Übergabevorbereitung',
    'obras.fase.FINALIZADA': 'Fertiggestellt',
    'obras.fase.DESCONOCIDO': 'Unbekannt',
    'obras.confianza.BAJA': 'Niedrig',
    'obras.confianza.MEDIA': 'Mittel',
    'obras.confianza.ALTA': 'Hoch',
    'obras.etapa.DETECTADA': 'Entdeckt',
    'obras.etapa.INVESTIGANDO': 'In Recherche',
    'obras.etapa.PENDIENTE_CONTACTAR': 'Zu kontaktieren',
    'obras.etapa.CONTACTADA': 'Kontaktiert',
    'obras.etapa.CONVERSACION': 'Gespräch begonnen',
    'obras.etapa.REUNION': 'Termin vereinbart',
    'obras.etapa.PROPUESTA': 'Angebot gesendet',
    'obras.etapa.GANADA': 'Gewonnen',
    'obras.etapa.PERDIDA': 'Verloren',
    'obras.etapa.PAUSA': 'Pausiert',
    'obras.tipo.VILLA': 'Einzelvilla',
    'obras.tipo.PROMOCION': 'Wohnanlage',
    'obras.tipo.APARTAMENTO': 'Wohnung oder Penthouse',
    'obras.tipo.REFORMA': 'Kernsanierung',
    'obras.tipo.OTRO': 'Sonstiges',
    'obras.rol.PROPIETARIO': 'Eigentümer',
    'obras.rol.PROMOTOR': 'Bauträger',
    'obras.rol.CONSTRUCTORA': 'Bauunternehmen',
    'obras.rol.ARQUITECTO': 'Architekt',
    'obras.rol.PROJECT_MANAGER': 'Projektsteuerung',
    'obras.rol.COMERCIALIZADORA': 'Vertriebsagentur',
    'obras.rol.AGENTE': 'Immobilienmakler',
    'obras.rol.OTRO': 'Weiterer Kontakt',
    'obras.influencia.DECIDE': 'Entscheidet',
    'obras.influencia.INFLUYE': 'Beeinflusst',
    'obras.influencia.INFORMA': 'Informiert',
    'obras.canal.TELEFONO': 'Telefon',
    'obras.canal.EMAIL': 'E-Mail',
    'obras.canal.WHATSAPP': 'WhatsApp',
    'obras.canal.PRESENCIAL': 'Persönlich',
    'obras.accionTipo.INVESTIGAR': 'Recherchieren',
    'obras.accionTipo.LLAMAR': 'Anrufen',
    'obras.accionTipo.EMAIL': 'E-Mail senden',
    'obras.accionTipo.WHATSAPP': 'WhatsApp senden',
    'obras.accionTipo.VISITAR': 'Besuchen',
    'obras.accionTipo.PRESENTACION': 'Präsentation anfragen',
    'obras.accionTipo.REUNION': 'Termin vereinbaren',
    'obras.accionTipo.PROPUESTA': 'Angebot vorbereiten',
    'obras.accionTipo.SEGUIMIENTO': 'Nachfassen',
    'obras.accionTipo.VERIFICAR': 'Fortschritt prüfen',
    'obras.accionTipo.OTRO': 'Sonstiges',
    'obras.apunte.CREACION': 'Vorhaben angelegt',
    'obras.apunte.ETAPA': 'Statuswechsel',
    'obras.apunte.PROGRESO': 'Bau-Update',
    'obras.apunte.CONTACTO': 'Kontakt',
    'obras.apunte.TAREA': 'Aufgabe',
    'obras.apunte.NOTA': 'Notiz',
    'obras.apunte.LLAMADA': 'Anruf',
    'obras.apunte.EMAIL': 'E-Mail',
    'obras.apunte.WHATSAPP': 'WhatsApp',
    'obras.apunte.VISITA': 'Besuch',
    'obras.apunte.REUNION': 'Termin',
    'obras.apunte.CONVERSION': 'Umwandlung',
    'obras.colNombre': 'Vorhaben',
    'obras.colFin': 'Fertigstellung',
    'obras.ordenar': 'Sortieren nach',
    'obras.orden.PUNTUACION': 'Bewertung',
    'obras.orden.PROGRESO': 'Fortschritt',
    'obras.orden.FINALIZACION': 'Fertigstellung',
    'obras.orden.VALOR': 'Wert',
    'obras.orden.COMPROBACION': 'Zuletzt geprüft',
    'obras.orden.ACCION': 'Nächste Aktion',
    'obras.nuevaTitulo': 'Neues Bauvorhaben',
    'obras.editar': 'Vorhaben bearbeiten',
    'obras.gIdentificacion': 'Bezeichnung und Lage',
    'obras.gConstruccion': 'Bau',
    'obras.gComercial': 'Vertriebsinformationen',
    'obras.gSituacion': 'Lage der Immobilie',
    'obras.nombreProvisional': 'Arbeitstitel',
    'obras.nombreEjemplo': 'Z. B.: Villa an der Klippe',
    'obras.direccionEjemplo': 'Z. B.: Cami de Son Vic 14',
    'obras.eligeZona': 'Gebiet wählen',
    'obras.situarTitulo': 'Auf der Karte verorten',
    'obras.situar': 'Adresse suchen',
    'obras.situando': 'Wird gesucht…',
    'obras.situada': 'Verortet in',
    'obras.noSituada': 'Diese Adresse wurde nicht gefunden. Gebiet von Hand eingeben und trotzdem speichern.',
    'obras.zonaEjemplo': 'z. B. Costa d’en Blanes',
    'obras.zonaNota': 'Das Gebiet kommt aus der Adresssuche und kann auch eingegeben werden. Es verortet das Bauvorhaben auf der Karte.',
    'obras.origen': 'Herkunft der Information',
    'obras.etiquetas': 'Schlagwörter',
    'obras.contactoMovil': 'Mobilnummer des Kontakts',
    'obras.contactoEmail': 'E-Mail des Kontakts',
    'obras.contactoNota': 'Wird als Hauptkontakt der Baustelle gespeichert. Weitere Kontakte kommen in ihre Akte.',
    'obras.etiquetasNota': 'Durch Kommas getrennt',
    'obras.propietarioConocido': 'Eigentümer bekannt',
    'obras.usoDelPropietario': 'Wird vom Eigentümer genutzt',
    'obras.saldraAVenta': 'Kommt in den Verkauf',
    'obras.yaEnVenta': 'Bereits im Verkauf',
    'obras.si': 'Ja',
    'obras.no': 'Nein',
    'obras.guardar': 'Vorhaben speichern',
    'obras.guardarCambios': 'Änderungen speichern',
    'obras.cancelar': 'Abbrechen',
    'obras.faltaNombre': 'Gib mindestens einen Arbeitstitel und ein Gebiet an.',
    'obras.sinGuardar': 'Es gibt ungespeicherte Änderungen.',
    'obras.errorGuardar': 'Konnte nicht gespeichert werden.',
    'obras.dupTitulo': 'Dieses Vorhaben ist möglicherweise schon erfasst',
    'obras.dupExplicacion': 'Es ähnelt einem vorhandenen Eintrag. Nichts wird automatisch zusammengeführt oder gelöscht: Du entscheidest.',
    'obras.dup.direccion': 'Gleiche Adresse',
    'obras.dup.nombre': 'Gleicher Name',
    'obras.dup.codigo': 'Gleicher Code',
    'obras.dup.promotor': 'Gleicher Bauträger oder Bauunternehmen',
    'obras.dup.zona': 'Gleiches Gebiet',
    'obras.dupAbrir': 'Vorhandenes öffnen',
    'obras.dupSeguir': 'Ist ein anderes, fortfahren',
    'obras.dupCancelar': 'Anlegen abbrechen',
    'obras.tab.resumen': 'Übersicht',
    'obras.tab.fotos': 'Fotos',
    'obras.tab.seguimiento': 'Verlauf',
    'obras.tab.contactos': 'Kontakte und Firmen',
    'obras.tab.tareas': 'Aufgaben',
    'obras.tab.obra': 'Bauinformationen',
    'obras.tab.historial': 'Historie',
    'obras.volverLista': 'Zurück zu den Vorhaben',
    'obras.situacionFisica': 'Baustand',
    'obras.situacionComercial': 'Vertriebsstand',
    'obras.riesgos': 'Was noch fehlt',
    'obras.riesgoSinPropietario': 'Der Eigentümer ist nicht bekannt',
    'obras.riesgoSinContacto': 'Es gibt weder Telefon noch E-Mail',
    'obras.riesgoSinFecha': 'Es gibt keinen geschätzten Fertigstellungstermin',
    'obras.riesgoVieja': 'Die Informationen wurden länger nicht geprüft',
    'obras.riesgoSinValor': 'Es gibt keinen geschätzten Marktwert',
    'obras.sinRiesgos': 'Es fehlt nichts Wesentliches.',
    'obras.comentarios': 'Anmerkungen zum Bau',
    'obras.cambiarEtapa': 'Status ändern',
    'obras.comentarioEtapa': 'Kommentar zur Änderung',
    'obras.motivoPerdida': 'Grund für den Verlust',
    'obras.pidePerdida': 'Um als verloren zu markieren, ist ein Grund nötig.',
    'obras.confirmarGanada': 'Als gewonnen markieren',
    'obras.consecuenciaGanada': 'Das Vorhaben wird als gewonnen geschlossen, und es wird angeboten, es in Kunde und Objekt umzuwandeln.',
    'obras.registrar': 'Erfassen',
    'obras.queHaPasado': 'Was ist passiert',
    'obras.seguimientoNota': 'Es wird in der Historie vermerkt. Es wird keine echte Nachricht gesendet.',
    'obras.anadirContacto': 'Kontakt hinzufügen',
    'obras.nombrePersonaEmpresa': 'Name der Person oder Firma',
    'obras.rolEnObra': 'Rolle beim Bau',
    'obras.telefono': 'Telefon',
    'obras.email': 'E-Mail',
    'obras.web': 'Website',
    'obras.idiomaContacto': 'Sprache',
    'obras.canalPreferido': 'Bevorzugter Kanal',
    'obras.nivelDecision': 'Einflussgrad',
    'obras.notas': 'Notizen',
    'obras.sinContactar': 'Möchte nicht kontaktiert werden',
    'obras.sinContactarAviso': 'Nicht kontaktieren',
    'obras.quitarContacto': 'Entfernen',
    'obras.sinContactos': 'Diesem Vorhaben ist noch niemand zugeordnet.',
    'obras.convertir': 'In Kunde und Objekt umwandeln',
    'obras.convertirTitulo': 'Vorhaben umwandeln',
    'obras.convertirNota': 'Simulation: Es werden ein fiktiver Kunde und ein fiktives Objekt angelegt und mit diesem Vorhaben verknüpft. Beim Neuladen verschwinden sie.',
    'obras.queSeLleva': 'Was übernommen wird',
    'obras.llevaContactos': 'Die Kontakte',
    'obras.llevaHistorial': 'Die Vertriebshistorie',
    'obras.llevaObra': 'Die Baudaten',
    'obras.nombreCliente': 'Name des Kunden',
    'obras.nombrePropiedad': 'Name des Objekts',
    'obras.confirmarConversion': 'Umwandeln',
    'obras.convertida': 'Umgewandelt in {cliente} und {propiedad}.',
    'obras.yaConvertida': 'Bereits umgewandelt',
    'obras.vacio': 'Noch keine Vorhaben erfasst.',
    'obras.vacioPie': 'Lege das erste über die Schaltfläche oben an.',
    'obras.sinResultados': 'Kein Vorhaben entspricht deiner Auswahl.',
    'obras.sinResultadosPie': 'Versuche, die Filter zurückzusetzen.',
    'obras.reiniciar': 'Demo zurücksetzen',
    'obras.accesoDenegado': 'Dieses Modul ist für das Vertriebsteam',
    'obras.accesoDenegadoPie': 'Dein Profil hat keinen Zugriff auf Bauvorhaben.',
    'obras.permisoSimulado': 'Die Berechtigungen in diesem Modul sind in der Oberfläche SIMULIERT. Sie sind keine Sicherheitsgrenze: Es gibt keinen Server, der sie prüft.',
    'obras.cargando': 'Chancen werden geladen…',
    'obras.noSeGuardo': '„{obra}“ konnte nicht gespeichert werden. Prüfen Sie die Verbindung und versuchen Sie es erneut.',
    'obras.fichas': 'Feldbögen',
    'obras.fichasTitulo': 'Feldbögen',
    'obras.fichasSub': 'Laden Sie die Fotos der Bögen des Tages hoch; sie werden nacheinander gelesen.',
    'obras.fichasSubir': 'Fotos der Bögen',
    'obras.fichasNota': 'Jedes Foto ergibt einen Entwurf zum Prüfen. Es wird nichts von allein angelegt: Sie speichern selbst, mit dem gewohnten Formular.',
    'obras.fichasLeyendo': '{total} Bogen/Bögen werden gelesen…',
    'obras.fichaLeyendo': 'Wird gelesen…',
    'obras.fichaNoSeLeyo': 'Dieser Bogen konnte nicht gelesen werden.',
    'obras.fichaSinNombre': 'Kein Name auf dem Bogen',
    'obras.fichaCamposLeidos': '{total} Feld(er) vom Papier gelesen:',
    'obras.fichaDudas': 'Nicht verstanden:',
    'obras.fichaRevisar': 'Prüfen und anlegen',
    'obras.campoNombre': 'Name',
    'obras.campoDireccion': 'Adresse',
    'obras.campoCp': 'Postleitzahl',
    'obras.campoMunicipio': 'Gemeinde',
    'obras.campoZona': 'Gebiet',
    'obras.campoTipo': 'Projektart',
    'obras.campoFase': 'Bauphase',
    'obras.campoProgreso': 'Fortschritt',
    'obras.campoFin': 'Fertigstellung',
    'obras.campoConfianza': 'Verlässlichkeit',
    'obras.campoComentario': 'Kommentar',
    'obras.campoEtapa': 'Vertriebsphase',
    'obras.campoResponsable': 'Zuständig',
    'obras.campoValor': 'Marktwert',
    'obras.campoContactos': 'Kontakte',
    'obras.promotor': 'Bauträger',
    'obras.promotorEjemplo': 'z. B.: Promociones Son Vida SL',
    'obras.guardando': 'Wird gespeichert…',
    'fotos.adjuntar': 'Fotos anhängen (JPG oder PNG, eines oder mehrere)',
    'fotos.altaNota': 'Sie werden beim Speichern mit dem heutigen Datum und Ihrem Namen hochgeladen – so lässt sich später mit neuen Fotos vergleichen, wie weit der Bau ist.',
    'fotos.alGuardar': 'Wird beim Speichern hochgeladen',
    'fotos.guardandoConFotos': 'Wird gespeichert, Fotos werden hochgeladen…',
    'fotos.noSubieron': 'Die Chance wurde gespeichert, aber {total} Foto(s) konnten nicht hochgeladen werden. Fügen Sie sie über den Reiter Fotos hinzu.',
    'obras.simularRol': 'Rolle simulieren',
    'obras.rolDireccion': 'Geschäftsführung',
    'obras.rolComercial': 'Vertrieb',
    'obras.rolOtro': 'Kunde oder Dienstleister',
    'obras.soloLectura': 'Nur lesen: Dieses Vorhaben ist dir nicht zugewiesen.',
    'nivelIncidencia.1': 'Notfall',
    'nivelIncidencia.2': 'Vorrangig',
    'nivelIncidencia.3': 'Planbar',
    'nivelIncidencia.4': 'Optische Verbesserung',
    'estadoIncidencia.OPEN': 'Offen',
    'estadoIncidencia.IN_PROGRESS': 'Laufend',
    'estadoIncidencia.CLOSED': 'Geschlossen',
    'estadoIncidencia.CANCELLED': 'Storniert',
    'tipoDocumento.CONTRATO': 'Vertrag',
    'tipoDocumento.SEGURO': 'Versicherung',
    'tipoDocumento.GARANTIA': 'Garantie',
    'tipoDocumento.FACTURA': 'Rechnung',
    'tipoDocumento.OTRO': 'Sonstiges',
    'areaMant.GESTION': 'Verwaltung',
    'frecuencia.SEMANAL': 'Wöchentlich',
    'frecuencia.QUINCENAL': 'Zweiwöchentlich',
    'frecuencia.MENSUAL': 'Monatlich',
    'frecuencia.TRIMESTRAL': 'Vierteljährlich',
    'frecuencia.SEMESTRAL': 'Halbjährlich',
    'frecuencia.ANUAL': 'Jährlich',
    'frecuencia.PERSONALIZADA': 'Individuell',
    'ficha.genera': 'Erzeugt',
    'ficha.antelacion': '{total}T Vorlauf',
    'estadoEstancia.PREVISTA': 'Geplant',
    'estadoEstancia.EN_CURSO': 'Laufend',
    'estadoEstancia.FINALIZADA': 'Beendet',
    'estadoEstancia.CANCELADA': 'Storniert',
    'ficha.resumen': 'Übersicht',
    'ficha.buscarIncidencia': 'Vorgang suchen',
    'ficha.incidencias': 'Vorgänge',
    'ficha.visitas': 'Besuche',
    'ficha.mantenimiento': 'Wartung',
    'ficha.proveedores': 'Dienstleister',
    'ficha.gastos': 'Ausgaben',
    'ficha.contratos': 'Verträge',
    'ficha.historial': 'Verlauf',
    'ficha.proximaVisita': 'Nächster Besuch',
    'ficha.ultimaVisita': 'Letzter Besuch',
    'ficha.visitasVencidas': '{total} überfällige Besuche',
    'ficha.sinVisitas': 'Noch keine Besuche',
    'ficha.incidenciasActivas': 'Offene Vorgänge',
    'ficha.gastoAcumulado': 'Gesamtausgaben',
    'ficha.horasCol': 'Stunden',
    'ficha.horasImputadas': '{total} h erfasst',
    'ficha.estancias': 'Aufenthalte des Kunden',
    'ficha.confirmarQuitarEstancia': 'Aufenthalt {cuando} entfernen? Er wird storniert, nicht gelöscht.',
    'ficha.sinEstancias': 'Keine Aufenthalte erfasst.',
    'ficha.llegada': 'Anreise',
    'ficha.salida': 'Abreise',
    'ficha.huesped': 'Gast',
    'ficha.registrarEstancia': 'Aufenthalt erfassen',
    'ficha.fotos': 'Fotos der Immobilie',
    'ficha.sinFotos': 'Noch keine Fotos.',
    'ficha.anadirFoto': 'Foto hinzufügen',
    'ficha.urlFoto': 'Bildadresse',
    'ficha.fotoPorUrl': 'Vorerst wird die Bildadresse gespeichert; der Datei-Upload ist ein eigenes Stück.',
    'ficha.tarifasEquipo': 'Teamsaetze',
    'ficha.rol': 'Rolle',
    'ficha.porHora': 'EUR/Stunde',
    'ficha.fijaMensual': 'Festsatz/Monat',
    'ficha.tarifaPrioridad': 'Der monatliche Festsatz hat Vorrang vor dem Stundensatz.',
    'ficha.mantenimientoExplicacion': 'Wartung wiederholt sich in einem Rhythmus; als erledigt markiert, wird das nächste Datum berechnet.',
    'ficha.sinMantenimiento': 'Keine geplante Wartung.',
    'ficha.cadaDias': 'alle {total} Tage',
    'ficha.puntual': 'einmalig',
    'ficha.proxima': 'Nächste',
    'ficha.marcarHecho': 'Als erledigt',
    'ficha.concepto': 'Aufgabe',
    'ficha.cadenciaDias': 'Rhythmus (Tage)',
    'ficha.anadirMantenimiento': 'Wartung hinzufügen',
    'ficha.proveedoresExplicacion': 'Die festen Dienstleister dieser Immobilie, damit man sie nicht jedes Mal sucht.',
    'ficha.sinProveedores': 'Keine Dienstleister verknüpft.',
    'ficha.vincularProveedor': 'Dienstleister verknüpfen',
    'ficha.vincular': 'Verknüpfen',
    'ficha.desvincular': 'Lösen',
    'ficha.gastosMesActual': 'Diesen Monat dieser Immobilie zugeordnete Ausgaben.',
    'acceso.lema': 'Alles von unserem Team überwacht, nach einem einzigen Qualitätsstandard.',
    'acceso.sub': 'Ganzheitliche Immobilienverwaltung — Besuche, Vorgänge und Vermögen unter einem Schlüssel.',
    'acceso.bienvenido': 'Willkommen zurück',
    'acceso.entrar': 'Anmelden',
    'areaMant.INTERIOR': 'Innen',
    'areaMant.EXTERIOR': 'Außen',
    'areaMant.SISTEMAS': 'Systeme',
    'areaMant.PISCINA': 'Pool',
    'areaMant.JARDIN': 'Garten',
    'areaMant.OTRO': 'Sonstiges',
    'estadoEvento.PREVISTA': 'Offen',
    'estadoEvento.EN_CURSO': 'Laufend',
    'estadoEvento.HECHA': 'Geschlossen',
    'estadoEvento.CANCELADA': 'Abgesagt',
    'ficha.ocupada': 'Belegt',
    'ficha.casaVacia': 'Haus leer',
    'ficha.sinSalida': 'Kein Auszugsdatum',
    'ficha.confirmarQuitarDocumento': '«{titulo}» entfernen? Die Datei wird mitgelöscht.',
    'visita.enCursoNoSeQuita': 'Dieser Besuch wird gerade durchgegangen. Erst abschließen oder abbrechen, dann aus dem Kalender entfernen.',
    'ajustes.categoriaRepetida': 'Eine Kategorie mit diesem Namen existiert bereits.',
    'ajustes.categoriaEnUso': 'Auf dieser Kategorie liegen Ausgaben: lieber deaktivieren statt löschen, dann zählen die alten Ausgaben weiter.',
    'ajustes.categoriaDelSistema': 'Diese Kategorie gehört zum System: umbenennen und deaktivieren ja, löschen nein.',
    'estancia.enCurso': 'Dieser Aufenthalt läuft gerade.',
    'visita.exigeFoto': 'Dieser Punkt verlangt ein Foto: erst fotografieren, dann abhaken.',
    'visita.pideFoto': 'Foto nötig',
    'visita.anadirFoto': 'Foto',
    'visita.faltanFotos': 'Der Besuch lässt sich nicht abschließen: Es fehlen Punkte, die ein Foto verlangen. Mach das Foto oder setze sie auf „Nicht zutreffend“.',
    'visita.hacerFoto': 'Foto machen',
    'visita.reabrir': 'Besuch wieder öffnen',
    'visita.reabrirPie': 'Um Fotos hinzuzufügen oder zu entfernen und Markierungen zu korrigieren.',
    'visita.subiendoFoto': 'Wird hochgeladen…',
    'visita.quitar': 'Aus dem Kalender entfernen',
    'visita.confirmarQuitar': '«{titulo}» aus dem Kalender entfernen?',
    'interno.titulo': 'Intern',
    'interno.subtitulo': 'Ausgaben und Stunden des Teams, ohne Immobilie',
    'interno.subtituloPropio': 'Deine eigene Historie von Stunden und Ausgaben. Nur deine.',
    'interno.total': 'Gesamtausgaben',
    'interno.registros': '{total} Einträge',
    'interno.pendientes': 'Zur Freigabe',
    'interno.pendientesPie': 'warten auf Entscheidung',
    'interno.sinContabilizar': 'Nicht verbucht',
    'interno.sinContabilizarPie': 'nicht in der Buchhaltung',
    'interno.horas': 'Stunden',
    'interno.gastos': 'Ausgaben',
    'interno.categoria': 'Kategorie',
    'interno.estado': 'Status',
    'interno.todasCategorias': 'Alle Kategorien',
    'interno.todosEstados': 'Alle Status',
    'interno.vacio': 'Keine Einträge.',
    'interno.fecha': 'Datum',
    'gasto.factura': 'Rechnung',
    'gasto.verFactura': 'Rechnung des Ausgabenpostens ansehen',
    'gasto.sinFactura': 'Zu dieser Ausgabe ist keine Rechnung hinterlegt. Hier hochladen.',
    'gasto.adjuntarFactura': 'Rechnung hochladen (Bild oder PDF)',
    'gasto.adjuntarOtra': 'Weitere hinzufügen (Bild oder PDF)',
    'gasto.formatosFactura': 'JPG, PNG, HEIC oder PDF. Bis zu 20 MB.',
    'gasto.subiendo': 'Wird hochgeladen…',
    'gasto.noSeSubio': 'Die Rechnung konnte nicht hochgeladen werden. Bitte erneut versuchen.',
    'gasto.abrirAparte': 'In neuem Tab öffnen',
    'carga.editar': 'Bearbeiten',
    'carga.eliminar': 'Entfernen',
    'carga.acciones': 'Aktionen',
    'carga.editarGasto': 'Ausgabe bearbeiten',
    'carga.editarHoras': 'Zeiterfassung bearbeiten',
    'carga.confirmarGasto': '„{concepto}“ entfernen? Sie zählt dann nicht mehr für den Monat und die Abrechnung.',
    'carga.confirmarHoras': 'Diesen Eintrag über {horas} entfernen? Er zählt dann nicht mehr für den Monat und die Vergütung.',
    'carga.guardar': 'Änderungen speichern',
    'carga.noSeGuardo': 'Die Änderungen konnten nicht gespeichert werden.',
    'carga.noSeQuito': 'Konnte nicht entfernt werden.',
    'carga.horas': 'Stunden',
    'carga.sinPropiedad': 'Intern (ohne Immobilie)',
    'interno.ambito': 'Welche Einträge anzeigen',
    'interno.ambitoInterno': 'Vom Team (ohne Immobilie)',
    'interno.ambitoCasas': 'Immobilien zugeordnet',
    'interno.ambitoTodo': 'Alle',
    'interno.propiedad': 'Immobilie',
    'fotos.titulo': 'Fotos',
    'fotos.subir': 'Fotos hochladen',
    'fotos.subiendo': '{total} Datei(en) werden hochgeladen…',
    'fotos.noSeSubio': '„{fichero}“ konnte nicht hochgeladen werden.',
    'fotos.quitar': 'Foto entfernen',
    'fotos.confirmarQuitar': 'Dieses Foto entfernen? Das lässt sich nicht rückgängig machen.',
    'fotos.noSeQuito': 'Das Foto konnte nicht entfernt werden.',
    'fotos.sinAutor': 'Ohne Urheber',
    'fotos.vacio': 'Noch keine Fotos.',
    'fotos.vacioPuede': 'Noch keine Fotos. Laden Sie das erste über die Schaltfläche oben hoch.',
    'fotos.obra': 'Fotos der Baustelle',
    'fotos.obraNota': 'Jedes Foto behält, wer es hochgeladen hat und wann – so zeigt der Vergleich, wie die Arbeiten vorankommen.',
    'fotos.tarea': 'Bilder',
    'interno.concepto': 'Beschreibung',
    'interno.beneficiario': 'Empfänger',
    'interno.contab': 'Verbucht',
    'interno.contabSi': 'Ja',
    'interno.contabNo': 'Nein',
    'interno.importe': 'Betrag',
    'interno.persona': 'Person',
    'interno.tipo': 'Art',
    'interno.descripcion': 'Notizen',
    'interno.horasCol': 'Stunden',
    'estadoGasto.PENDIENTE_APROBACION': 'Freigabe offen',
    'estadoGasto.APROBADO': 'Freigegeben',
    'estadoGasto.RECHAZADO': 'Abgelehnt',
    'estadoGasto.PAGADO': 'Bezahlt',
    'categoriaGasto.LOGISTICA': 'Logistik',
    'categoriaGasto.COMPRA': 'Einkauf',
    'categoriaGasto.OTRO': 'Sonstiges',
    'categoriaGasto.MARKETING': 'Marketing',
    'categoriaGasto.VEHICULOS': 'Fahrzeuge / Kraftstoff',
    'categoriaGasto.PROPERTY_MANAGEMENT': 'Property-Management-Kosten',
    'categoriaGasto.OFICINA': 'Büro',
    'categoriaGasto.PROVEEDORES_CLIENTES': 'Kundenbezogene Dienstleister',
    'categoriaGasto.EQUIPO': 'Team',
    'categoriaGasto.GASTOS_GENERALES': 'Allgemeine Kosten',
    'categoriaGasto.REAL_ESTATE': 'Real-Estate-Kosten',
    'categoriaGasto.SOFTWARE': 'Software',
    'categoriaGasto.SERVICIOS': 'Dienstleistungen',
    'categoriaGasto.RECUPERABLES': 'Erstattungsfähige Kosten',
    'categoriaGasto.LIMPIEZA': 'Reinigung',
    'categoriaGasto.GESTORIA': 'Steuer / Recht / Verwaltung',
    'categoriaGasto.OTROS_DIRECTOS': 'Sonstige direkte Kosten',
    'tipoHora.GESTION': 'Verwaltung',
    'tipoHora.OTRO': 'Sonstiges',
    'tipoHora.MANTENIMIENTO': 'Wartung',
    'tipoHora.LIMPIEZA': 'Reinigung',
    'tipoHora.OBRA': 'Bauarbeiten',
    'tipoHora.ADMINISTRACION': 'Administration',
    'tipoHora.COMERCIAL': 'Vertrieb',
    'tipoHora.DESPLAZAMIENTO': 'Fahrt',
    'estadoPropiedad.ONBOARDING': 'In Aufnahme',
    'estadoPropiedad.ACTIVE': 'Aktiv',
    'estadoPropiedad.SUSPENDED': 'Ausgesetzt',
    'estadoPropiedad.INTERNAL_DEMO': 'Intern oder Demo',
    'estadoPropiedad.ARCHIVED': 'Archiviert',
    'requisito.DIRECCION': 'Adresse',
    'requisito.ZONA': 'Gebiet',
    'requisito.PROPIETARIO': 'Mindestens ein Eigentümer',
    'requisito.CONTRATO': 'Gültiger Verwaltungsvertrag',
    'requisito.CLIENTE_FACTURACION': 'Rechnungsempfänger',
    'requisito.TARIFA': 'Gültige Pauschale',
    'requisito.NIO_VALIDADA': 'Validierte Betriebsbewertung',
    'requisito.RESPONSABLE_INTERNO': 'Interne Verantwortung',
    'semaforo.VERDE': 'Im Plan',
    'semaforo.AMARILLO': 'Achtung',
    'semaforo.ROJO': 'Risiko',
    'rol.DIRECTOR': 'Geschäftsführung',
    'rol.MANAGER': 'Manager',
    'rol.PROVEEDOR': 'Dienstleister',
    'rol.CLIENTE': 'Kunde',
    'rol.PROMOTOR': 'Bauträger',
    'portal.soloMirar': 'Du siehst dieses Objekt als Beobachter: Du kannst alles einsehen, aber nichts eintragen oder schreiben.',
    'rol.CAPTADOR': 'Akquisiteur',
    'crm.pipelines': 'Pipelines',
    'crm.pipelinesPie': 'Der gewohnte Vertriebstrichter: Chancen nach Phase.',
    'crm.obras': 'Bauvorhaben',
    'crm.obrasPie': 'Laufende Bauten, aus denen Objekte werden können.',
    'pap.titulo': 'Tür zu Tür',
    'pap.sub': 'Straßenarbeit: welche Straßen wir gemacht haben und wie es lief.',
    'pap.registrar': 'Tür erfassen',
    'pap.nuevaPuerta': 'Neue Tür',
    'pap.estoyAqui': 'Ich bin hier',
    'pap.ubicando': 'Adresse wird gesucht…',
    'pap.sinGps': 'Dieses Gerät gibt keinen Standort. Adresse eintippen.',
    'pap.noSePudoUbicar': 'Standort nicht lesbar. Adresse eintippen.',
    'pap.direccion': 'Adresse',
    'pap.zona': 'Gegend',
    'pap.municipio': 'Gemeinde',
    'pap.codigoPostal': 'Postleitzahl',
    'pap.situarTitulo': 'Wo genau es liegt',
    'pap.situarPie': 'Tippe auf die Karte oder zieh die Nadel auf das Haus. Gespeichert wird mit Speichern.',
    'pap.atendieron': 'Hat jemand aufgemacht?',
    'pap.queDijeron': 'Was haben sie gesagt?',
    'pap.respuestaOtra': 'Mit eigenen Worten',
    'pap.contacto': 'Name des Kontakts',
    'pap.contactoPie': 'Optional',
    'pap.telefono': 'Telefon',
    'pap.notas': 'Notizen',
    'pap.material': 'Abgegebenes Material',
    'pap.fotos': 'Fotos',
    'pap.fotosPie': 'Die Fassade und alles Vernachlässigte: Garten, Tor, Pool.',
    'pap.hacerFoto': 'Foto machen',
    'pap.anadirFoto': 'Foto hinzufügen',
    'pap.subiendo': 'Wird hochgeladen…',
    'pap.fotosElegidas': '{total} Fotos bereit',
    'pap.fotosGuardadas': '{total} Fotos im Datensatz gespeichert',
    'pap.fotosPerdidas': '{total} Fotos konnten nicht hochgeladen werden. Die Tür ist erfasst; füge sie im Datensatz hinzu.',
    'pap.guardar': 'Speichern und weiter',
    'pap.guardando': 'Wird gespeichert…',
    'pap.guardada': 'Tür erfasst',
    'pap.siguiente': 'Nächste Tür',
    'pap.terminar': 'Fertig',
    'pap.mapa': 'Karte des Begangenen',
    'pap.vista.mapa': 'Karte',
    'pap.vista.zonas': 'Gegenden',
    'pap.vista.lista': 'Liste',
    'pap.buscar': 'Straße, Gegend oder Name suchen',
    'pap.todas': 'Alle',
    'pap.estadoTitulo': 'Status',
    'pap.estado.ATENDIO': 'Aufgemacht',
    'pap.estado.NO_ATENDIO': 'Niemand da',
    'pap.estado.SEGUIMIENTO': 'Nachfassen',
    'pap.estado.DESCARTADA': 'Verworfen',
    'pap.estado.CLIENTE': 'Jetzt Kunde',
    'pap.respuesta.YA_TIENE_GESTOR': 'Hat schon eine Verwaltung',
    'pap.respuesta.NO_INTERESA': 'Kein Interesse',
    'pap.respuesta.DEJA_INFORMACION': 'Lass mir Unterlagen da',
    'pap.respuesta.LLAMA_MAS_ADELANTE': 'Später anrufen',
    'pap.respuesta.SEGUNDA_RESIDENCIA': 'Ist ein Zweitwohnsitz',
    'pap.respuesta.NO_ES_PROPIETARIO': 'Nicht der Eigentümer',
    'pap.respuesta.QUIERE_INFORMACION': 'Möchte Informationen',
    'pap.respuesta.OTRA': 'Andere',
    'pap.material.FLYER': 'Flyer',
    'pap.material.TARJETA': 'Karte',
    'pap.material.AMBOS': 'Beides',
    'pap.material.NINGUNO': 'Nichts',
    'pap.seguimientos': 'Nachfassen und Aufgaben',
    'pap.nuevoSeguimiento': 'Was hier zu tun ist',
    'pap.sinSeguimientos': 'Hier steht nichts an.',
    'pap.historial': 'Verlauf',
    'pap.sinHistorial': 'Noch nichts passiert.',
    'pap.zonasRecorridas': 'Begangene Gegenden',
    'pap.zonaResumen': '{puertas} Türen · {atendidas} mit Antwort',
    'pap.vacio': 'Noch keine Tür erfasst.',
    'pap.sinEnEsteFiltro': 'Hier ist nichts.',
    'pap.noSeCargaron': 'Die Türen konnten nicht geladen werden.',
    'pap.confirmarQuitar': 'Diese Tür entfernen? Das lässt sich nicht rückgängig machen.',
    'party.titulo': 'Personen und Unternehmen',
    'party.vacio': 'Noch keine Personen oder Unternehmen vorhanden.',
    'party.nueva': 'Neue Person oder Unternehmen',
    'party.editar': 'Bearbeiten',
    'party.tipo': 'Typ',
    'party.pais': 'Land (ISO)',
    'party.nif': 'Steuernummer',
    'party.nifSoloFacturacion': 'Nur nötig, wenn Rechnungen gestellt werden',
    'party.direccionFacturacion': 'Rechnungsadresse',
    'party.telefono': 'Telefon',
    'party.PERSONA_FISICA': 'Natürliche Person',
    'party.EMPRESA': 'Unternehmen',
    'party.COMUNIDAD_PROPIETARIOS': 'Eigentümergemeinschaft',
    'party.OTRA_ENTIDAD_JURIDICA': 'Sonstige juristische Person',
    'party.archivada': 'Dieser Eintrag ist archiviert.',
    'party.datosFacturacionIncompletos': 'Rechnungsdaten unvollständig: Steuernummer, E-Mail oder Rechnungsadresse.',
    'party.enUso': 'Archivieren nicht möglich: es bestehen noch Verträge oder Beziehungen.',
    'relacion.OWNER': 'Eigentümer',
    'relacion.PROMOTER': 'Bauträger',
    'relacion.ASSET_MANAGER': 'Verwaltungsgesellschaft',
    'relacion.AUTHORIZED_CONTACT': 'Bevollmächtigter Kontakt',
    'relacion.vacio': 'Noch keine Beziehungen vorhanden.',
    'relacion.rol': 'In welcher Eigenschaft',
    'relacion.desde': 'Ab',
    'relacion.anadir': 'Beziehung hinzufügen',
    'relacion.finalizar': 'Beenden',
    'relacion.motivoFin': 'Grund der Beendigung',
    'relacion.historicas': 'Frühere Beziehungen',
    'contrato.titulo': 'Verwaltungsvertrag',
    'contrato.vacio': 'Noch kein Vertrag vorhanden.',
    'contrato.DRAFT': 'Entwurf',
    'contrato.ACTIVE': 'Gültig',
    'contrato.TERMINATED': 'Beendet',
    'contrato.crear': 'Vertrag anlegen',
    'contrato.desde': 'Beginn',
    'contrato.moneda': 'Währung',
    'contrato.umbral': 'Freigabegrenze des Kunden',
    'contrato.tarifa': 'Pauschale',
    'contrato.importe': 'Betrag',
    'contrato.importeOpcional': 'optional: es gilt die vorgeschlagene Pauschale',
    'contrato.modalidadTarifa': 'Art der Pauschale',
    'contrato.fijarTarifa': 'Pauschale festlegen',
    'contrato.activar': 'Vertrag aktivieren',
    'contrato.congelada': 'Betrag bei Aktivierung eingefroren',
    'contrato.historicos': 'Frühere Verträge',
    'contrato.finalizar': 'Vertrag beenden',
    'contrato.hasta': 'Wirksames Enddatum',
    'contrato.motivoFin': 'Grund für die Beendigung',
    'contrato.finalizarConsecuencias': 'Der Vertrag endet zu diesem Datum, und die Gültigkeit seiner Pauschale endet am selben Tag. Ist die Immobilie aktiv, wird sie im selben Vorgang stillgelegt. Nichts wird gelöscht: Vertrag und Pauschale bleiben in der Historie.',
    'contrato.clienteFacturacion': 'Rechnungsempfänger',
    'contrato.modalidad.MANUAL': 'Manuelle Pauschale',
    'contrato.modalidad.NIO': 'Pauschale nach Serviceniveau',
    'contrato.tarifaCongelada': 'Die Pauschale eines gültigen Vertrags ist eingefroren.',
    'contrato.nioNoValidada': 'Eine Pauschale nach Serviceniveau erfordert eine validierte Bewertung.',
    'contrato.nioDeOtraPropiedad': 'Diese Bewertung gehört zu einer anderen Immobilie.',
    'contrato.estadoInvalido': 'Der Vertrag lässt diese Aktion in seinem Status nicht zu.',
    'contrato.sinPagador': 'Der Rechnungsempfänger fehlt.',
    'contrato.sinTarifa': 'Die Pauschale fehlt.',
    'propiedad.estadoSinCambio': 'Die Immobilie hat diesen Status bereits.',
    'propiedad.transicionNoPermitida': 'Dieser Statuswechsel ist nicht zulässig.',
    'propiedad.motivoObligatorio': 'Dieser Statuswechsel erfordert eine Begründung.',
    'propiedad.requisitosPendientes': 'Es fehlen noch Voraussetzungen.',
    'propiedad.incidenciasAbiertas': 'Es gibt offene Vorgänge: bitte zuerst schließen oder stornieren.',
    'propiedad.noOperativa': 'Die Immobilie ist nicht in Betrieb.',
    'propiedad.contratoVigente': 'Es besteht ein gültiger Vertrag: bitte zuerst beenden, dann archivieren.',
    'cicloVida.titulo': 'Lebenszyklus',
    'cicloVida.suspender': 'Immobilie stilllegen',
    'cicloVida.reactivar': 'Immobilie reaktivieren',
    'cicloVida.archivar': 'Immobilie archivieren',
    'cicloVida.motivo': 'Begründung',
    'cicloVida.suspenderConsecuencias': 'Sie ist nicht mehr in Betrieb. Der Vertrag bleibt gültig und seine Pauschale unverändert: Stilllegen beendet ihn nicht. Eine Reaktivierung ist möglich.',
    'cicloVida.reactivarConsecuencias': 'Sie geht wieder in Betrieb. Erfordert einen gültigen Vertrag und alle erfüllten Voraussetzungen.',
    'cicloVida.archivarConsecuencias': 'Sie verlässt das Portfolio endgültig. Erfordert eine Begründung, keine offenen Vorgänge und keinen gültigen Vertrag. Die Historie bleibt vollständig erhalten, die Immobilie wird jedoch nicht mehr bewirtschaftet.',
    'cicloVida.archivada': 'Immobilie archiviert. Die Historie bleibt vollständig erhalten. Sie kann wiederhergestellt werden: sie kehrt mit derselben Akte in die Aufnahme zurück.',
    'cicloVida.restaurar': 'Immobilie wiederherstellen',
    'cicloVida.restaurarConsecuencias': 'Sie kehrt mit derselben Kennung, ihren Beziehungen und ihrer gesamten Historie in die Aufnahme zurück. Es wird keine neue Akte angelegt. Um wieder aktiv zu sein, muss sie erneut alle Voraussetzungen erfüllen und über einen gültigen Vertrag verfügen.',
    'nio.titulo': 'Betriebsbewertung',
    'nio.vacio': 'Noch keine Bewertung vorhanden.',
    'nio.nueva': 'Neue Bewertung',
    'nio.sustituir': 'Durch eine neue ersetzen',
    'nio.editar': 'Entwurf bearbeiten',
    'nio.validar': 'Validieren',
    'nio.total': 'Gesamt',
    'nio.yaHayBorrador': 'Für diese Immobilie gibt es bereits einen Entwurf.',
    'nio.explicacion': 'Operative Intensitätsstufe: wird aus sechs Faktoren mit je 1 bis 5 Punkten berechnet und bestimmt die vorgeschlagene Pauschale.',
    'nio.factorInvalido': 'Jeder Faktor muss eine ganze Zahl zwischen 1 und 5 sein.',
    'nio.sinTablaBase': 'Es ist keine Basistabelle konfiguriert.',
    'nio.soloBorradorEditable': 'Nur ein Entwurf kann bearbeitet werden.',
    'nio.estadoInvalido': 'Die Bewertung lässt diese Aktion in ihrem Status nicht zu.',
    'nio.BORRADOR': 'Entwurf',
    'nio.VALIDADA': 'Validiert',
    'nio.SUSTITUIDA': 'Ersetzt',
    'nio.cuotaSugerida': 'Vorgeschlagene Pauschale',
    'nio.factor.valorActivo': 'Objektwert',
    'nio.factor.complejidadTecnica': 'Technische Komplexität',
    'nio.factor.frecuenciaUso': 'Nutzungshäufigkeit',
    'nio.factor.exigenciaCliente': 'Anspruchsniveau des Kunden',
    'nio.factor.exposicionClimatica': 'Witterungsexposition',
    'nio.factor.historialIntervencion': 'Historie und Eingriffe',
    'incidencia.titulo': 'Vorgänge',
    'incidencia.vacio': 'Keine Vorgänge.',
    'incidencia.crear': 'Vorgang erfassen',
    'incidencia.descripcion': 'Beschreibung',
    'incidencia.acciones': 'Aktionen',
    'incidencia.cerrar': 'Schließen',
    'incidencia.anular': 'Stornieren',
    'incidencia.resolucion': 'Lösung',
    'incidencia.motivo': 'Grund',
    'incidencia.OPEN': 'Offen',
    'incidencia.IN_PROGRESS': 'Laufend',
    'incidencia.CLOSED': 'Geschlossen',
    'incidencia.CANCELLED': 'Storniert',
    'incidencia.estadoInvalido': 'Der Vorgang lässt diese Aktion in seinem Status nicht zu.',
    'incidencia.sugerencia': 'Die KI schlägt S{nivel} — {nombre} vor.',
    'incidencia.usarSugerencia': 'Übernehmen',
    'incidencia.agregar': 'Vorfall hinzufügen',
    'incidencia.tituloCampo': 'Titel',
    'incidencia.area': 'Bereich',
    'incidencia.costeEstimado': 'Geschätzte Kosten (€)',
    'incidencia.fotos': 'Bilder',
    'incidencia.anadirFotos': '📷 Bilder hinzufügen',
    'incidencia.quitarFoto': 'Dieses Bild entfernen',
    'incidencia.nivel': 'Stufe',
    'incidencia.nivel.1': 'Notfall',
    'incidencia.nivel.2': 'Vorrangig',
    'incidencia.nivel.3': 'Planbar',
    'incidencia.nivel.4': 'Optische Verbesserung',
    'idioma.es': 'Spanisch',
    'idioma.en': 'Englisch',
    'idioma.de': 'Deutsch',
};
//# sourceMappingURL=de.js.map